<template>
<div ref="scrollContainer" id="page-panel" v-loading="fullScreenLoading" class="scrollable only-y">
   <div class="customer-top-nav-shell">
      <el-card class="customer-top-nav-card" :class="{ 'customer-top-nav-card--scrolled': isCustomerTopNavScrolled }" shadow="never">
         <div class="customer-top-nav">
            <el-page-header @back="close()" class="customer-page-header">
               <div slot="title">
                  <span class="hidden-sm-and-down">{{$t('common.back')}}</span>
               </div>
               <div slot="content">
                  <el-tooltip v-if="!isCustomerActive" :content="$i18n.t('clients.deactivatedCustomer')" placement="top">
                     <i  class="mdi mdi-account-off"></i>
                  </el-tooltip>
                  <span v-else>
                     <el-tooltip v-if="isIndividual" :content="$i18n.t('clients.individual')" placement="top">
                        <i class="mdi mdi-account-circle align-vertical-middle customer-type"></i>
                     </el-tooltip>
                     <el-tooltip v-else :content="$i18n.t('clients.corporate')"  placement="top">
                        <i class="mdi mdi-city align-vertical-middle customer-type"></i>
                     </el-tooltip>
                  </span>
                  <span :class="{inactive : !isCustomerActive}" class="customer-name-text">{{customerNameValue}}</span>
                  <span v-if="customer && customer.tags" class="customer-inline-tags">
                     <el-tag class="customer-inline-tag" v-for="tag in customer.tags" :key="tag.id">{{ tag.code }}</el-tag>
                  </span>
               </div>
            </el-page-header>
               <div class="customer-controls">
               <!-- <el-button @click="close();">{{$t('buttons.close')}}</el-button> -->
               <el-tooltip content="Historique d'achats" placement="top">
                  <el-button size="small" style="margin-right:4px;border-radius:8px;padding:9px 10px;" @click="purchaseHistoryVisible = true">
                     <i class="mdi mdi-history" style="font-size:16px;"></i>
                  </el-button>
               </el-tooltip>
               <el-dropdown v-if="$can('write', 'Customer')">
                  <el-button type="primary" size="small" style="margin-left:5px;">
                     Actions <i class="el-icon-arrow-down"></i>
                     <!-- <i class="el-icon-more"></i> -->
                  </el-button>
                  <el-dropdown-menu slot="dropdown" >
                     <el-dropdown-item :disabled="!customer.active " @click.native="openCustomerEditor" ><i class="mdi mdi-account-edit"><span style="padding-left:5px;">{{$t('clients.editCustomer')}}</span></i></el-dropdown-item>
                     <el-dropdown-item :disabled="!customer.active" @click.native="openVisitDrawer()"><i class="mdi mdi-calendar-plus"><span style="padding-left:5px;">{{$t('clients.visitsList.createVisitReport')}}</span></i></el-dropdown-item>
                        <el-dropdown-item :disabled="!customer.active" @click.native="openVisitDrawer(null, 'planning')"><i class="mdi mdi-calendar-clock"><span style="padding-left:5px;">{{$t('clients.visitsList.planVisit')}}</span></i></el-dropdown-item>
                     <el-dropdown-item :disabled="!customer.active " @click.native="handleCreateNewSalesOrder" ><i class="mdi mdi-file-move"><span style="padding-left:5px;">{{$t('clients.createSalesOrder')}}</span></i></el-dropdown-item>
                     <el-dropdown-item v-if="isInvoicingModuleactive === true" @click.native="handleShowWalletManagementDialog(true)"><i class="mdi mdi-credit-card-lock"><span style="padding-left:5px;">{{$t('clients.manageWallet')}}</span></i></el-dropdown-item>
                     <el-dropdown-item v-if="isInvoicingModuleactive === true" :disabled="!customer.active" @click.native="createCredit"><i class="mdi mdi-credit-card-minus"><span style="padding-left:5px;">{{$t('clients.addCreditNote')}}</span></i></el-dropdown-item>
                     <el-dropdown-item v-if="isInvoicingModuleactive === true"@click.native="openSenerateStatementFilter('SIMPLE')" divided><i class="mdi mdi-book-variant"><span style="padding-left:5px;">{{ $t('clients.simpleStatementReport') }}</span></i></el-dropdown-item>
                     <el-dropdown-item v-if="isInvoicingModuleactive === true"@click.native="sendSimpleStatement"><i class="mdi mdi-email-fast"><span style="padding-left:5px;">{{ $t('clients.sendSimpleStatementReport') }}</span></i></el-dropdown-item>
                     <el-dropdown-item v-if="isInvoicingModuleactive === true"@click.native="openSenerateStatementFilter" ><i class="mdi mdi-book-variant"><span style="padding-left:5px;">{{$t('clients.statementReport')}}</span></i></el-dropdown-item>
                     <el-dropdown-item @click.native="downloadReservationUpcomingOrderReport" divided><i class="mdi mdi-file-pdf-box"><span style="padding-left:5px;">{{$t('clients.reservationNextSalesOrder')}}</span></i></el-dropdown-item>
                     <el-dropdown-item :disabled="!customer.active" @click.native="sendReservationReminder"><i class="mdi mdi-email-fast"><span style="padding-left:5px;">{{$t('clients.sendReservationReminder')}}</span></i></el-dropdown-item>
                     <el-dropdown-item @click.native="archiveCustomerControl" v-if="this.customer.active" :divided="true"><i class="mdi mdi-account-off"><span style="padding-left:5px;">{{$t('clients.deactivateCustomer')}}</span></i></el-dropdown-item>
                     <el-dropdown-item @click.native="archiveCustomerControl" v-if="!this.customer.active" :divided="true"><i class="mdi mdi-account-star-outline"><span style="padding-left:5px;">{{$t('clients.activateCustomer')}}</span></i></el-dropdown-item>
                     <el-dropdown-item @click.native="convertCustomer" ><i class="mdi mdi-account-convert"><span style="padding-left:5px;">{{$t('clients.convert')}} {{convertClientType}}</span></i></el-dropdown-item>
                     <el-dropdown-item @click.native="deleteCustomer"><i class="mdi mdi-delete"><span style="padding-left:5px;">{{$t('clients.delete')}}</span></i></el-dropdown-item>
                  </el-dropdown-menu>
               </el-dropdown>
            </div>
      </div>
      </el-card>
   </div>
   <el-card class="customer-main-card">
      <div class="customer-tab-nav customer-tab-nav--desktop">
         <el-radio-group v-model="activeTab" class="customer-tab-group">
            <el-radio-button label="1"><i class="el-icon-notebook-2"/><span class="customer-tab-label">{{$t('clients.tabs.clientInfo')}}</span></el-radio-button>
            <el-radio-button label="8"><i class="el-icon-date"/><span class="customer-tab-label">{{$t('clients.tabs.visits')}}</span></el-radio-button>
            <el-radio-button label="2"><i class="el-icon-collection-tag"/><span class="customer-tab-label">{{$t('clients.tabs.reservations')}}</span></el-radio-button>
            <el-radio-button label="3"><i class="el-icon-shopping-cart-full"/><span class="customer-tab-label">{{$t('clients.tabs.sales')}}</span></el-radio-button>
            <el-radio-button label="4" v-if="isInvoicingModuleactive === true"><i class="el-icon-shopping-cart-full"/><span class="customer-tab-label">{{$t('clients.tabs.invoicesCreditNote')}}</span></el-radio-button>
            <el-radio-button label="5"><i class="el-icon-postcard"/><span class="customer-tab-label">{{$t('clients.tabs.communication')}}</span></el-radio-button>
            <el-radio-button label="6"><i class="el-icon-files"/><span class="customer-tab-label">{{$t('clients.tabs.notes')}}</span></el-radio-button>
            <el-radio-button label="7"><i class="el-icon-setting"/><span class="customer-tab-label">{{$t('clients.tabs.configuration')}}</span></el-radio-button>
         </el-radio-group>
      </div>
      <div class="customer-tab-nav-mobile">
         <el-select v-model="activeTab" class="customer-tab-select" size="small" placeholder="Navigation">
            <el-option :label="$t('clients.tabs.clientInfo')" value="1"></el-option>
            <el-option :label="$t('clients.tabs.visits')" value="8"></el-option>
            <el-option :label="$t('clients.tabs.reservations')" value="2"></el-option>
            <el-option :label="$t('clients.tabs.sales')" value="3"></el-option>
            <el-option v-if="isInvoicingModuleactive === true" :label="$t('clients.tabs.invoicesCreditNote')" value="4"></el-option>
            <el-option :label="$t('clients.tabs.communication')" value="5"></el-option>
            <el-option :label="$t('clients.tabs.notes')" value="6"></el-option>
            <el-option :label="$t('clients.tabs.configuration')" value="7"></el-option>
         </el-select>
      </div>
      <!-- Fiche client -->
      <div v-if="activeTab==1" :style="tabHeight">
         <el-row class="customer-stats-section">
            <div style="display:block">
               <el-row :gutter="12" class="stats-overview-layout">
                  <el-col v-if="isInvoicingModuleactive === true && $can('read', 'Invoices')" :xs="24" :sm="24" :md="24" :lg="14" :xl="14">
                     <div class="stats-block stats-finance-block">
                        <div class="stats-group-title">{{$t('clients.financialIndicatorsTitle')}}</div>
                        <div class="finance-priority-row">
                           <div class="finance-priority-item finance-priority-item--danger">
                              <div class="finance-priority-label">{{ $i18n.t('clients.stats.overdue') }}</div>
                              <div class="finance-priority-value">{{ formatAmount(overdue) }}</div>
                           </div>
                           <div class="finance-priority-item finance-priority-item--warning">
                              <div class="finance-priority-label">{{ $i18n.t('clients.stats.outstanding') }}</div>
                              <div class="finance-priority-value">{{ formatAmount(outstanding) }}</div>
                           </div>
                        </div>
                        <div class="finance-compact-grid">
                           <div class="finance-compact-item">
                              <span class="finance-compact-label">{{ $i18n.t('clients.stats.draft') }}</span>
                              <span class="finance-compact-value">{{ formatAmount(draft) }}</span>
                           </div>
                           <div class="finance-compact-item">
                              <span class="finance-compact-label">{{ $i18n.t('clients.stats.paid') }}</span>
                              <span class="finance-compact-value">{{ formatAmount(total_paid) }}</span>
                           </div>
                           <div class="finance-compact-item">
                              <span class="finance-compact-label">{{ $i18n.t('clients.stats.credit') }}</span>
                              <span class="finance-compact-value">{{ formatAmount(credit) }}</span>
                           </div>
                           <div class="finance-compact-item">
                              <span class="finance-compact-label">{{ $i18n.t('clients.stats.total') }}</span>
                              <span class="finance-compact-value">{{ formatAmount(total_revenue) }}</span>
                           </div>
                        </div>
                     </div>
                  </el-col>

                  <el-col :xs="24" :sm="24" :md="24" :lg="isInvoicingModuleactive === true && $can('read', 'Invoices') ? 10 : 24" :xl="isInvoicingModuleactive === true && $can('read', 'Invoices') ? 10 : 24">
                     <div class="stats-block stats-visit-block">
                        <div class="stats-group-title">{{$t('clients.visitIndicatorsTitle')}}</div>
                        <div class="visit-indicators-row">
                           <div class="visit-indicator-card card-shadow--medium">
                              <div class="visit-indicator-label">{{$t('clients.lastVisitDate')}}</div>
                              <div v-if="lastVisitDateValue != null">
                                 <div class="visit-indicator-head">
                                    <div class="visit-indicator-main">
                                       <div class="visit-indicator-value">{{ formattedLastVisitDate }}</div>
                                       <div class="visit-indicator-badge" :class="lastVisitStatusClass">
                                          {{ lastVisitStatusLabel }}
                                       </div>
                                    </div>
                                    <el-tooltip
                                       v-if="latestVisitForReport != null"
                                       :content="$t('clients.visitsList.viewLastVisitReport')"
                                       placement="top">
                                       <el-button
                                          type="text"
                                          icon="el-icon-document"
                                          class="visit-indicator-report-action"
                                          @click="openVisitDrawer(latestVisitForReport)">
                                       </el-button>
                                    </el-tooltip>
                                 </div>
                              </div>
                              <div v-else class="visit-indicator-empty">
                                 <i class="mdi mdi-calendar-remove-outline visit-indicator-empty-icon"></i>
                                 <span>{{$t('clients.noVisitToDate')}}</span>
                                 <el-button
                                    v-if="$can('write', 'Customer') && customer && customer.active"
                                    type="text"
                                    size="mini"
                                    class="visit-indicator-empty-action"
                                    @click="openVisitDrawer()">
                                    {{$t('clients.visitsList.createVisitReport')}}
                                 </el-button>
                              </div>

                              <div class="visit-next-row">
                                 <span class="visit-next-label">{{$t('clients.nextVisitDate')}}:</span>
                                 <span class="visit-next-value">{{ formattedNextVisitDate }}</span>
                                 <el-tooltip
                                    v-if="nextVisitDateValue == null && $can('write', 'Customer') && customer && customer.active"
                                    :content="$t('clients.visitsList.planVisit')"
                                    placement="top">
                                    <el-button
                                       type="text"
                                       icon="el-icon-date"
                                       class="visit-next-action"
                                       @click="openVisitDrawer(null, 'planning')">
                                    </el-button>
                                 </el-tooltip>
                                 <el-tooltip
                                    v-if="isNextVisitToday && $can('write', 'Customer') && customer && customer.active"
                                    :content="$t('clients.visitsList.createVisitReport')"
                                    placement="top">
                                    <el-button
                                       type="text"
                                       icon="el-icon-circle-plus-outline"
                                       class="visit-next-action"
                                       @click="openVisitDrawer()">
                                    </el-button>
                                 </el-tooltip>
                              </div>
                           </div>

                           <div class="visit-indicator-card visit-indicator-card--distribution card-shadow--medium">
                              <div class="visit-indicator-label">{{$t('clients.visitDistribution')}}</div>
                              <div v-if="visitDistributionLoading" class="secondary-text fs-12">{{$t('clients.loadingVisits')}}</div>
                              <div v-else-if="totalVisitCount === 0" class="secondary-text fs-12">{{$t('clients.noVisitRecorded')}}</div>
                              <div v-else class="visit-distribution-compact">
                                 <div class="visit-distribution-bar">
                                    <div
                                       v-for="row in visitDistributionRows"
                                       v-if="row.count > 0"
                                       :key="`segment-${row.code}`"
                                       class="visit-distribution-segment"
                                       :style="{ width: `${row.percent}%`, backgroundColor: row.color }"
                                       :title="`${row.label}: ${row.count}`"></div>
                                 </div>

                                 <div class="visit-distribution-legend">
                                    <div v-for="row in visitDistributionRows" :key="row.code" class="visit-distribution-pill">
                                       <span class="visit-distribution-dot" :style="{ backgroundColor: row.color }"></span>
                                       <span class="visit-distribution-type">{{ row.label }}</span>
                                       <span class="visit-distribution-count">{{ row.count }}</span>
                                    </div>
                                 </div>
                              </div>
                           </div>
                        </div>
                     </div>
                  </el-col>
               </el-row>
            </div>
         </el-row>
         <el-row :gutter="20">
            <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
               <h5>{{$t('clients.infos')}}</h5>
               <el-divider />
               <!-- <el-form label-position="right"> -->
               <el-row :gutter="10" v-if="customer!= null && customer.parent != null">
                  <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
                     <span class="fs-14" style="color:#606266">{{$t('clients.groupedUnderCsutomer')}} : </span>
                     <span class="fs-14">
                        <PortausLink :id="customer.parent.id" path="/customers/" :label="getCustomerName(customer.parent)"></PortausLink>
                     </span>
                  </el-col>
               </el-row>
               <el-row :gutter="10">
                  <el-col :xs="24" :sm="24" :md="24" :lg="12" :xl="12">
                     <span class="fs-14" style="color:#606266">{{$t('clients.customerNumber')}} : </span>
                     <span class="fs-14">{{customer.id}}</span>
                  </el-col>
                  <el-col :xs="24" :sm="24" :md="24" :lg="12" :xl="12">
                     <span class="fs-14" style="color:#606266">{{$t('clients.type')}} : </span>
                     <span class="fs-14">{{getTypeOfCustomer}}</span>
                  </el-col>
               </el-row>
               <el-row :gutter="10">
                  <el-col :xs="24" :sm="24" :md="24" :lg="12" :xl="12">
                     <span class="fs-14" style="color:#606266">{{isIndividual ? $t('clients.customerName') :  $t('clients.companyName')}} : </span>
                     <span class="fs-14">{{customer.name}}</span>
                  </el-col>
                  <el-col :xs="24" :sm="24" :md="24" :lg="12" :xl="12" v-if="!isIndividual && customer.usual_name!=null && customer.usual_name!=''">
                     <span class="fs-14" style="color:#606266">{{$t('clients.usualName')}} : </span>
                     <span class="fs-14">{{customer.usual_name}}</span>
                  </el-col>
               </el-row>
               <el-row :gutter="10" v-if="!isIndividual">
                  <el-col :xs="24" :sm="24" :md="24" :lg="12" :xl="12" >
                     <span class="fs-14" style="color:#606266">{{$t('clients.phone')}} : </span>
                     <span class="fs-14">{{customer.company.phone?customer.company.phone: $t('common.notAvailable')}}</span>
                     <span class="fs-14" v-if="customer.company.phoneExt!=null && customer.company.phoneExt!=''">
                        <nobr> Ext.: {{customer.company.phoneExt}}</nobr>
                     </span>
                  </el-col>
                  <el-col :xs="24" :sm="24" :md="24" :lg="12" :xl="12">
                     <span class="fs-14" style="color:#606266">{{$t('clients.email')}} : </span>
                     <Email :email="customer.company.email" :mailTo="true"></Email>
                  </el-col>
               </el-row>
               <el-row :gutter="10">
                  <el-col :xs="24" :sm="24" :md="24" :lg="12" :xl="12">
                     <span class="fs-14" style="color:#606266">{{$t('clients.class')}} : </span>
                     <span class="fs-14">{{customer.customer_class?customer.customer_class.code: $t('common.notAvailable')}}</span>
                  </el-col>
                  <el-col :xs="24" :sm="24" :md="24" :lg="12" :xl="12">
                     <span class="fs-14" style="color:#606266">{{$t('clients.tags')}} : </span>
                     <span class="fs-14" v-if="customer!=null">
                        <el-tag style="margin-left:5px;" v-for="tag in customer.tags" :key="tag.id" >{{tag.code}}</el-tag>
                     </span>
                     <span class="fs-14" v-if="customer!=null && customer.tags!=null && customer.tags.length==0">{{ $t('common.notAvailable') }}</span>
                  </el-col>
               </el-row>
               <h5>{{$t('clients.repAndTerritory')}}</h5>
               <el-row :gutter="10">
                  <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="12">
                     <span class="fs-14" style="color:#606266">{{$t('clients.territory')}} : </span>
                     <span class="fs-14">{{customer.territory?customer.territory.code: $t('common.none')}}</span>
                  </el-col>
                  <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="12">
                     <span class="fs-14" style="color:#606266">{{$t('clients.rep')}} : </span>
                     <span class="fs-14" v-if="customer.rep">
                        {{customer.rep.first_name + ' ' + customer.rep.last_name}}
                        <span class="rep-initials-avatar">{{ getRepInitials(customer.rep) }}</span>
                     </span>
                     <span class="fs-14" v-else>{{$t('common.none')}}</span>
                  </el-col>
               </el-row>
               <h5>{{$t('clients.personnalizedFiled')}}</h5>
               <el-divider />
               <span class="fs-14" style="color:#606266">{{$t('clients.externalId')}}</span>
               <span class="fs-14">{{customer.externalId}}</span>
               <!-- <div v-for="info in customer_fields" :key="info.id">
                  <span class="fs-14" style="color:#606266">{{getInfoTitle(info)}} : </span>
                  <span class="fs-14">{{info.value}}</span>
               </div> -->
            </el-col>
            <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
               <h5 v-if="!isIndividual">{{$t('clients.principalContact')}}</h5>
               <h5 v-else>{{$t('clients.contact')}}</h5>
               <el-divider />
               <ContactCards @onAccountChange="handleChangeAccount" :customerId="customerId" v-bind:contacts="getContacts" type="primary"  :webAccounts="webAccounts" v-bind:isIndividual="isIndividual" :compact="true"></ContactCards>
               <div v-if="!isIndividual">
                  <h5>{{$t('clients.secondaryContact')}}</h5>
                  <el-divider />
                  <ContactCards @onAccountChange="handleChangeAccount" :customerId="customerId"  v-bind:contacts="getContacts"	type="secondary"  :webAccounts="webAccounts" :compact="true"></ContactCards>
               </div>
               <h5>{{$t('clients.addresses')}}</h5>
               <el-divider />
               <div>
                  <div v-for="address in getAddresses" :key="address.id" class="customer-address-item">
                     <AddressCard :ctrlVisible="false" shadow="never" :address="address" class="customer-address-card"></AddressCard>
                     <div v-if="getAddressMapEmbedUrl(address)" class="customer-address-map-card">
                        <div class="customer-address-map-header">
                           <span class="fs-12 secondary-text">{{$t('clients.addressLocation')}}</span>
                           <a :href="getAddressMapLink(address)" target="_blank" rel="noopener noreferrer" class="fs-12">{{$t('clients.openMap')}}</a>
                        </div>
                        <iframe
                           class="customer-address-map"
                           loading="lazy"
                           :title="`Carte - ${getAddressQuery(address)}`"
                           :src="getAddressMapEmbedUrl(address)">
                        </iframe>
                     </div>
                  </div>
                  <div v-if="getAddresses!=null && getAddresses.length==0" class="secondary-text fs-14 m-20">{{$t('clients.noAddresses')}}</div>
               </div>
            </el-col>
         </el-row>
      </div>
      <!-- Visites -->
      <div v-if="activeTab==8" :style="tabHeight">
         <el-row :gutter="20" class="mt-10">
            <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
               <div class="flex end align-center">
                  <el-button
                     v-if="$can('write', 'Customer') && customer && customer.active"
                     type="primary"
                     size="mini"
                     @click="openVisitDrawer()">
                     {{$t('clients.visitsList.createVisitReport')}}
                  </el-button>
               </div>
               <el-divider/>
               <div v-if="visitDistributionLoading" class="secondary-text fs-13 m-10">{{$t('clients.loadingVisits')}}</div>
               <template v-else>
                  <h5>Visites planifiées à venir</h5>
                  <div v-if="sortedUpcomingPlannedCustomerVisits.length === 0" class="secondary-text fs-13 m-10">Aucune visite planifiée à venir</div>
                  <el-table v-else :data="sortedUpcomingPlannedCustomerVisits" size="mini" stripe class="mb-20">
                     <el-table-column v-if="$can('write', 'Customer')" :label="$t('common.Actions')" width="110" align="center" fixed="left">
                        <template slot-scope="scope">
                           <div v-if="customer && customer.active" class="visit-row-actions">
                              <el-tooltip content="Modifier la planification" placement="top">
                                 <el-button
                                    type="text"
                                    icon="el-icon-edit"
                                    @click="openVisitDrawer(scope.row, 'planning')">
                                 </el-button>
                              </el-tooltip>
                              <el-tooltip content="Supprimer la planification" placement="top">
                                 <el-button
                                    type="text"
                                    icon="el-icon-delete"
                                    class="danger"
                                    @click="handleDeleteVisit(scope.row)">
                                 </el-button>
                              </el-tooltip>
                           </div>
                        </template>
                     </el-table-column>
                     <el-table-column :label="$t('common.date')" min-width="150">
                        <template slot-scope="scope">
                           <span>{{ formatVisitPlannedDateTime(scope.row) }}</span>
                        </template>
                     </el-table-column>
                     <el-table-column :label="$t('clients.type')" min-width="90" align="center">
                        <template slot-scope="scope">
                           <el-tooltip :content="visitTypeLabel(getVisitTypeCode(scope.row))" placement="top">
                              <i :class="getVisitTypeIcon(getVisitTypeCode(scope.row))"></i>
                           </el-tooltip>
                        </template>
                     </el-table-column>
                     <el-table-column :label="$t('clients.contacts')" min-width="220">
                        <template slot-scope="scope">
                           <span>{{ getVisitContactsSummary(scope.row) }}</span>
                        </template>
                     </el-table-column>
                     <el-table-column :label="$t('clients.tabs.notes')" min-width="260" show-overflow-tooltip>
                        <template slot-scope="scope">
                           <span>{{ getVisitNotes(scope.row) }}</span>
                        </template>
                     </el-table-column>
                  </el-table>

                  <h5>Visites réelles</h5>
                  <div v-if="sortedReportedCustomerVisits.length === 0" class="secondary-text fs-13 m-10">{{$t('clients.noVisitRecorded')}}</div>
                  <el-table v-else :data="sortedReportedCustomerVisits" size="mini" stripe>
                  <el-table-column v-if="$can('write', 'Customer')" :label="$t('common.Actions')" width="110" align="center" fixed="left">
                     <template slot-scope="scope">
                        <div v-if="customer && customer.active" class="visit-row-actions">
                           <el-tooltip :content="$t('clients.editVisitTooltip')" placement="top">
                              <el-button
                                 type="text"
                                 icon="el-icon-edit"
                                 @click="openVisitDrawer(scope.row)">
                              </el-button>
                           </el-tooltip>
                           <el-tooltip :content="$t('clients.deleteVisitTooltip')" placement="top">
                              <el-button
                                 type="text"
                                 icon="el-icon-delete"
                                 class="danger"
                                 @click="handleDeleteVisit(scope.row)">
                              </el-button>
                           </el-tooltip>
                        </div>
                     </template>
                  </el-table-column>
                  <el-table-column :label="$t('common.date')" min-width="120">
                     <template slot-scope="scope">
                        <span>{{ _moment(getVisitDate(scope.row), 'YYYY-MM-DD') }}</span>
                     </template>
                  </el-table-column>
                  <el-table-column :label="$t('clients.type')" min-width="90" align="center">
                     <template slot-scope="scope">
                        <el-tooltip :content="visitTypeLabel(getVisitTypeCode(scope.row))" placement="top">
                           <i :class="getVisitTypeIcon(getVisitTypeCode(scope.row))"></i>
                        </el-tooltip>
                     </template>
                  </el-table-column>
                  <el-table-column :label="$t('clients.contacts')" min-width="220">
                     <template slot-scope="scope">
                        <span>{{ getVisitContactsSummary(scope.row) }}</span>
                     </template>
                  </el-table-column>
                  <el-table-column :label="$t('clients.nextVisitDate')" min-width="180">
                     <template slot-scope="scope">
                        <span>{{ formatVisitNextDateTime(scope.row) }}</span>
                     </template>
                  </el-table-column>
                  <el-table-column label="Produits dégustés" width="130" align="center">
                     <template slot-scope="scope">
                        <span>{{ getVisitTastedProductsCount(scope.row) }}</span>
                     </template>
                  </el-table-column>
                  <el-table-column label="Niveaux d'intérêt" min-width="320">
                     <template slot-scope="scope">
                        <div class="visit-interest-cell">
                           <div v-if="getVisitInterestedProductsTotal(scope.row) === 0" class="secondary-text fs-12">
                              Aucun
                           </div>
                           <div v-else>
                              <div class="visit-interest-bar">
                                 <div
                                    v-for="row in getVisitInterestSummaryRows(scope.row)"
                                    :key="`${scope.$index}-${row.code}-bar`"
                                    class="visit-interest-segment"
                                    :style="{ width: `${row.percent}%`, backgroundColor: row.color }"
                                    :title="`${row.label}: ${row.count}`"></div>
                              </div>
                              <div class="visit-interest-legend-compact">
                                 <el-tooltip
                                    v-for="row in getVisitInterestSummaryRows(scope.row)"
                                    :key="`${scope.$index}-${row.code}-legend`"
                                    :content="getVisitInterestTooltip(row)"
                                    placement="top">
                                    <span class="visit-interest-legend-item" :title="`${row.label}: ${row.count}`">
                                       <span class="visit-interest-dot" :style="{ backgroundColor: row.color }"></span>
                                       <span class="visit-interest-short-label">{{ row.shortLabel }}</span>
                                       <span class="visit-interest-count">{{ row.count }}</span>
                                    </span>
                                 </el-tooltip>
                              </div>
                           </div>
                        </div>
                     </template>
                  </el-table-column>
                  <el-table-column :label="$t('clients.tabs.notes')" min-width="260" show-overflow-tooltip>
                     <template slot-scope="scope">
                        <span>{{ getVisitNotes(scope.row) }}</span>
                     </template>
                  </el-table-column>
                  </el-table>
               </template>
            </el-col>
         </el-row>
      </div>
      <!-- Réservations -->
      <div v-if="activeTab==2 && $can('read', 'SalesOrders')" :style="tabHeight">
         <CustomerReservations :customerId="customerId"></CustomerReservations>
      </div>
      <!-- Ventes -->
      <div v-if="activeTab==3 && $can('read', 'SalesOrders')" :style="tabHeight">
         <el-row :gutter="20" class="mt-20">
            <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
               <salesGraphics :customerId="customerId" title="Évolution des ventes (12 derniers mois)"></salesGraphics>
            </el-col>
			<el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
				<el-col :xs="24" :sm="12" :md="24" :lg="24" :xl="24">
					<InfoStatsCard  text="Valeur" v-bind:total="totalSales.value" v-bind:sign="'$'" v-bind:icon="'mdi mdi-account-cash'"  v-bind:status="'accent'" ></InfoStatsCard>
					
					</el-col>
					<el-col :xs="24" :sm="12" :md="24" :lg="24" :xl="24">
					<InfoStatsCard  text="Frais d'agence" v-bind:total="totalSales.agencyfees" v-bind:sign="'$'" v-bind:icon="'mdi mdi-bank'"  v-bind:status="'success'" ></InfoStatsCard>
					
					</el-col>
					<el-col :xs="24" :sm="12" :md="24" :lg="24" :xl="24">
					<InfoStatsCard  text="Rabais" v-bind:total="totalSales.discount" v-bind:sign="'$'" v-bind:icon="'mdi mdi-bank-minus'"  v-bind:status="'warning'" ></InfoStatsCard>
					
					</el-col>
					<el-col :xs="24" :sm="12" :md="12" :lg="12" :xl="12" v-if="!isMultipleInventorySystem">
					<InfoStatsCard  text="Qty bt." v-bind:total="totalSales.qty" v-bind:sign="''" v-bind:icon="'mdi mdi-numeric-1-circle'"  v-bind:status="'info'" ></InfoStatsCard>
					
					</el-col>
					<el-col :xs="24" :sm="12" :md="12" :lg="12" :xl="12"  v-if="!isMultipleInventorySystem">
					<InfoStatsCard  text="Qty 9L" v-bind:total="totalSales.qty9l" v-bind:sign="''" v-bind:icon="'mdi mdi-numeric-9-circle-outline'"  v-bind:status="'info'" ></InfoStatsCard>
					
				</el-col>
			</el-col>
            <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
               <h4>{{$t('clients.currentSalesOrder')}}</h4>
               <div class="flex center m-10 mt-10">
                  <Pagination
                     class="box right mt-5 mb-0 fs-14 secondary-text"
                     :current-page="page"
                     :total-number-of-page="totalPages"
                     @click-previous="fetchPreviousSalesOrderPage"
                     v-if="isNotEmpty"
                     @click-next="fetchNextSalesOrderPage" />
               </div>
               <el-divider/>
               <salesOrderTable :customerId="customerId" :salesOrders="salesOrders" height="100%" class="mb-20"></salesOrderTable>
            </el-col>
         </el-row>
      </div>
      <!-- facturation -->
      <div v-if="activeTab==4 && $can('read', 'Invoices')&& isInvoicingModuleactive === true" :style="tabHeight">
         <el-row :gutter="20">
            <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
               <!-- <el-link type="primary" style="float:right;margin-top:20px;">Voir toutes les factures</el-link> -->
               <h5>{{$t('clients.invoices')}}</h5>
               <el-divider/>
               <invoiceTable  :showFilter="true" :showDetails="false" :sortingOrder="date" sortingDirection='DESC' :paging="true" :perPage="15" :customerId="customerId" :filter="{statusCode : ['DRAFT','SENT','PARTIALLY_PAID', 'TO_SEND', 'PAID', 'IMPORTED']}" :sortable="true" :admin="true"></invoiceTable>
            </el-col>
            <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
               <h5>{{$t('clients.creditsNotes')}}</h5>
               <el-divider/>
               <creditNoteTable :customerId="customerId" :filter="{statusCodes : ['INIT','PARTIALLY_PAID']}" :sortable="true"></creditNoteTable>
            </el-col>
         </el-row>
      </div>
      <!-- Communications -->
      <div v-if="activeTab==5 && $can('read', 'CRM report')" :style="tabHeight" class="scrollable only-y">
         <EmailsCommunicationTable :lazy="true" :customer="customer"></EmailsCommunicationTable>
      </div>
      <!-- Notes -->
      <div v-if="activeTab==6" :style="tabHeight">
         <el-col >
            <h5>
               Notes 
               <el-button  plain type="text" @click="handleShowQuickNoteVisible"><i class="el-icon-circle-plus" /></el-button>
            </h5>
            <el-divider/>
            <CustomerNoteHistory :customerId="customerId" @edit="handleNoteEdition"></CustomerNoteHistory>
         </el-col>
         <QuickNoteModal :customerId="customerId" :visible="quickNoteModalVisible" :note="noteToEdit" @close="handleCloseQuickNoteVisible"></QuickNoteModal>
      </div>
      <!-- configuration -->
      <div v-if="activeTab==7" :style="tabHeight">
         <el-row :gutter="20">
            <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
               <h5>{{$t('clients.classification')}}</h5>
               <el-divider/>
               <el-row :gutter="10">
                  <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
                     <span class="fs-14" style="color:#606266">{{$t('clients.class')}} : </span>
                     <span class="fs-14">{{customer.customer_class?customer.customer_class.code : $t('common.notAvailable')}}</span>
                  </el-col>
                  <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
                     <span class="fs-14" style="color:#606266">{{$t('clients.tags')}} : </span>
                     <span class="fs-14" v-if="customer!=null">
                        <el-tag style="margin-left:5px;" v-for="tag in customer.tags" :key="tag.id" >{{tag.code}}</el-tag>
                     </span>
                     <span class="fs-14" v-if="customer!=null && customer.tags!=null && customer.tags.length==0">{{ $t('common.notAvailable') }}</span>
                  </el-col>
               </el-row>
            </el-col>
            <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
               <h5>{{$t('clients.currencyLanguage')}}</h5>
               <el-divider/>
               <el-row :gutter="10">
                  <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
                     <span class="fs-14" style="color:#606266">{{$t('clients.currency')}} : </span>
                     <span class="fs-14">{{customer.currency!=null?customer.currency.code: $t('common.notAvailable')}}</span>
                  </el-col>
                  <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
                     <span class="fs-14" style="color:#606266">{{$t('clients.language')}} : </span>
                     <span class="fs-14" v-if="customer.language!=null">{{customer.language.name}}</span>
                     <span class="fs-14" v-else>{{ $t('common.notAvailable') }}</span>
                  </el-col>
               </el-row>
            </el-col>
         </el-row>
         <el-row :gutter="20" v-if="isInvoicingModuleactive === true">
            <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
               <h5>{{$t('clients.paymentOptions')}}</h5>
               <el-divider/>
               <el-row :gutter="10">
                  <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
                     <span class="fs-14" style="color:#606266">{{$t('clients.paymentMethods')}} : </span>
                     <div v-if="customer!=null && customer.paymentOptions!=null && customer.paymentOptions.length>0">
                        <ul>
                           <div v-for="option in customer.paymentOptions">
                              <li><span class="fs-14">{{$t('invoices.'+option.code)}}</span></li>
                           </div>
                        </ul>
                     </div>
                     <span v-else class="secondary-text fs-14">{{$t('clients.noPaymentMethod')}}</span>
                  </el-col>
               </el-row>
            </el-col>
            <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
               <h5>{{ $t('clients.invoicing') }}</h5>
               <el-divider/>
               <el-row :gutter="10">
                  <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
                     <span class="fs-14" style="color:#606266">{{ $t('clients.invoicingOption') }}: </span>
                     <span v-if="customer.online_invoicing_ind" class="fs-14">{{ $t('clients.onlineInvoicing') }}</span>
                     <span v-else class="fs-14">Man{{ $t('clients.manualInvoicing') }}uel</span>
                  </el-col>
                  <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
                     <span class="fs-14" style="color:#606266">{{ $t('clients.term') }} : </span>
                     <span v-if="customer.invoice_term" class="fs-14">{{$t('invoices.terms.'+customer.invoice_term.code)}}</span>
                     <span v-else class="fs-14">{{ $t('common.notAvailable') }}</span>
                  </el-col>
                  <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
                     <span class="fs-14" style="color:#606266">{{ $t('clients.lateFees') }} : </span>
                     <span class="fs-14">{{customer.late_fee_activated?'Oui':'Non'}}</span>
                  </el-col>
                  <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24" v-if="customer.late_fee_activated">
                     <span class="fs-14" style="color:#606266">{{ $t('clients.fees') }} : </span>
                     <span class="fs-14">{{customer.fee}} {{customer.ind_type_fee==0?'%':'$'}}</span>
                  </el-col>
                  <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24" v-if="customer.late_fee_activated">
                     <span class="fs-14" style="color:#606266">{{ $t('clients.when') }} : </span>
                     <span class="fs-14">{{customer.grace_period}} {{ $t('clients.daysAfter') }}</span>
                  </el-col>
                  <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
                     <span class="fs-14" style="color:#606266">{{ $t('clients.taxesCode') }} : </span>
                     <span v-for="(taxe, index) in customer.taxes" :key="taxe.id" class="fs-14">{{taxe.name}}<span v-if="index < customer.taxes.length-1">, </span></span>
                  </el-col>
               </el-row>
            </el-col>
         </el-row>
         <el-row :gutter="20">
            <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
               <h5>{{$t('clients.deliveryPref')}}</h5>
               <el-divider/>
               <el-row :gutter="10">
                  <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
                     <span class="fs-14" style="color:#606266">{{$t('clients.deliveryType')}} : </span>
                     <span class="fs-14" v-if="customer.delivery_type!=null">{{deliveryType}}</span>
                     <span class="fs-14" v-else>{{ $t('common.notAvailable') }}</span>
                  </el-col>
                  <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24" v-if="customer.delivery_type!=null && customer.delivery_type.code=='DELIVERY'">
                     <BranchTile class="fs-14" style="border:1px dashed #DCDFE6;padding:10px;margin-top:10px;" v-if="customer.extra_info" :location="customer.extra_info.location.content"></BranchTile>
                  </el-col>
               </el-row>
               <el-row :gutter="10">
                  <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
                     <span class="fs-14" style="color:#606266">{{$t('clients.calendar')}} : </span>
                     <span class="fs-14">{{$t('clients.deliveryScheduleType.'+deliveryScheduleType)}}</span>
                  </el-col>
                  <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
                     <span class="fs-14" style="color:#606266">{{$t('clients.deliveryDays')}} : </span>
                     <span class="fs-14">{{deliveryDays}}</span>
                  </el-col>
               </el-row>
            </el-col>
            <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
               <h5>{{$t('clients.notifications.notifications')}}</h5>
               <el-divider/>
               <el-row :gutter="10">
                  <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
                     <span class="fs-14" style="color:#606266">{{$t('clients.notifications.paymentReminder')}} : </span>
                     <span class="fs-14">{{customer.reminder_activated? $t('common.activated'):$t('common.notActivated')}}<span v-if="customer.reminder_activated">, {{customer.nb_days_reminder}} {{$t('clients.daysBefore')}}</span></span>
                  </el-col>
                  <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
                     <span class="fs-14" style="color:#606266">{{$t('clients.notifications.lateFeeNotice')}} : </span>
                     <span class="fs-14">{{customer.late_fee_notification_activated? $t('common.activated'):$t('common.notActivated')}}</span>
                  </el-col>
               </el-row>
            </el-col>
         </el-row>
      </div>
      <CustomerEditor :visible="customerEditorVisible" :customerToEdit="customerToEdit" @close="closeCustomerEditor" @updated="refreshCustomer"></CustomerEditor>
      <CreditNoteEditor :visible="creditEditorVisible" :customer="customer" @close="creditEditorVisible=false"></CreditNoteEditor>
      <customerStatementFilter :visible="customerStatementVisible"
         predefinePeriodLabelCode='predefinedDate'
         @close="closeFilterDialog"
         :predefinedPeriod="predefinedPeriod"
         :period="period"
         :startDate="this.filters.startDate"
         :endDate="this.filters.endDate"
         @applyFilter="downloadStatement">
      </customerStatementFilter>
      <sendNoticeDialog  :defaultEmailContent="defaultEmailContent" :visible="sendDialogVisible" :forceSendAttachment="true" :customerId="customerId" type="CUSTOMER_STATEMENT" :object="customer" @close="closeSendNoticeDialog" @sent="noticeSent"></sendNoticeDialog>
   </el-card>
   <SalesOrderDialog :customerId="customerId != null ? String(customerId) : null" :dialogVisible="showSalesOrderDialog" @close="showSalesOrderDialog = false"></SalesOrderDialog>
   <CustomerPurchaseHistoryDialog
      v-if="purchaseHistoryVisible"
      :visible="purchaseHistoryVisible"
      :customerId="customerId"
      :customerName="customerNameValue"
      @close="purchaseHistoryVisible = false" />
   <WatingDialog :visible="downloading"></WatingDialog>
   <walletManagement 
      :visible="walletDialogVisible" 
      :customerId="customerId"
      :portausCompanyId="portausCompany" 
      @close="handleShowWalletManagementDialog(false)" />
   <VisitCreationDrawer
      :visible="visitDrawerVisible"
      :customerId="customerId"
      :customerName="customerNameValue"
      :contacts="getContacts || []"
      :mode="visitDrawerMode"
      :visitToEdit="visitToEdit"
      @close="closeVisitDrawer"
      @saved="handleVisitSaved" />
</div>
</template>

<script>
import moment from 'moment-timezone'
import ContactCards from '@/components/Contact-card-by-type'
import InfoStatsCard from '@/components/Info-stat-card'
import portausUtils from '@/utils/portaus-utils';
import CompanyInfo from '@/components/Company-info'
import axios from "axios"
import VuePerfectScrollbar from 'perfect-scrollbar'
import AddressCard from '@/components/address/Address-Card'
import SystemAPI from '@/services/API/system'
import QuickNoteModal from '@/components/quick-note-modal.vue'
import SalesOrdersAPI from '@/services/API/sales-order'
import SalesOrderDialog from '@/components/salesOrder/create-sales-order-dialog';
import CustomerEditor from '@/components/customer/Customer-editor'
import CreditNoteEditor from '@/components/creditNote/credit-note-editor'
import salesOrderTable from '@/components/dashboards/sales-order/sales-order-table.vue'
import invoiceTable from '@/components/invoice/invoice-table.vue'
import creditNoteTable from '@/components/creditNote/credit-note-table.vue'
import customerStatementFilter from '@/components/customer/customer-statement-filter.vue'
import { mapActions, mapState, mapGetters } from 'vuex';
import BranchTile from '@/components/Branch-tile'
import Email from '@/components/email'
import CustomerAPI from '@/services/API/customer'
import salesAPI from '@/services/API/sales'
import reservationAPI from '@/services/API/reservation'
import WatingDialog from '@/components/waiting-dialog'
import PortausLink from '@/components/portaus-link'
import CustomerUtil from '@/utils/customer-util'
import Pagination from '@/components/pagination'
import accountAPI from '@/services/API/account'
import walletManagement from '@/components/payments/wallet-management-dialog'
import salesGraphics from '@/components/sales-graphic'
import sendNoticeDialog from '@/components/send-notice-dialog.vue'
import VisitCreationDrawer from '@/components/visit/visit-creation-drawer.vue'
import VisitAPI from '@/services/API/visit'

export default {
   name: 'Customer',
  data() {
    return {
      downloading : false,
      simpleStatementObject: null,
      sendDialogVisible: false,
	  accessLoading: false,
      quickNoteModalVisible: false,
	  webAccounts: [],
	  fullScreenLoading: true,
         activeTab : '1',
  		customer : {company:{}, contacts: []},
			customer_fields : [],
	  	dialogvisible : false,
			salesOrders : [],
			pageWidth : 0,
			pageHeight : 0,
			customerEditorVisible : false,
			customerToEdit : null,
			creditEditorVisible : false,
			customerStatementVisible : false,
			filters : {
        range : null,
        startDate : null,
        endDate : null,
        customerId : null,
		
		
      },
			period : {code : 'LAST_12_MONTH'},
      noteToEdit: null,
      noteIndexToEdit: null,
        isCustomerTopNavScrolled: false,
	  page: 1,
	  totalPages: null,
	  salesOrderLimit: 15,
	  walletDialogVisible : false,
     totalSales: null,
     showSalesOrderDialog: false,
     purchaseHistoryVisible: false,
     visitDrawerVisible: false,
       visitToEdit: null,
   visitDrawerMode: 'report',
   visitFetchRequestId: 0,
    latestVisitDateFromVisits: null,
	 visitDistributionRows: [],
	 customerVisits: [],
	 visitDistributionLoading: false,
	};
		
  },components: {
		CustomerEditor,
      ContactCards,
      InfoStatsCard,
      VuePerfectScrollbar,
      CompanyInfo,
      WatingDialog,
		AddressCard,
      sendNoticeDialog,
		CustomerNoteHistory : () => import('@/components/note-history.vue'),
		invoiceTable,
		QuickNoteModal,
		// salesOrderDashboardCard,
		salesOrderTable,
		CustomerReservations: () => import('@/components/reservation/customer-reservations'),
		EmailsCommunicationTable : () => import('@/components/emails/emails-communication-table.vue'),
		BranchTile,
		CreditNoteEditor,
		creditNoteTable,
		Email,
		customerStatementFilter,
      PortausLink,
      CustomerUtil,
		Pagination,
		walletManagement,
		salesGraphics,
      SalesOrderDialog,
      CustomerPurchaseHistoryDialog: () => import('@/components/customer/customer-purchase-history-dialog.vue'),
      VisitCreationDrawer,
  },
	methods: {
	      openVisitDrawer(visit = null, mode = 'report') {
         const shouldSuggestPlannedVisit = visit == null
            && mode === 'report'
            && this.customer != null
            && this.customer.active;

         const resolveVisitPromise = shouldSuggestPlannedVisit
            ? this.maybeResolvePlannedVisitForReportCreation()
            : Promise.resolve(visit);

         resolveVisitPromise
            .then((resolvedVisit) => {
               const effectiveVisit = resolvedVisit || visit;
               const isPlannedVisit = effectiveVisit != null && _.toUpper(_.get(effectiveVisit, 'status')) === 'PLANNED';
               const resolvedMode = mode === 'report'
                  ? 'report'
                  : (isPlannedVisit ? 'planning' : mode);

               this.visitToEdit = effectiveVisit;
               this.visitDrawerMode = resolvedMode;
               this.visitDrawerVisible = true;
            })
            .catch(() => {
               this.visitToEdit = visit;
               this.visitDrawerMode = mode;
               this.visitDrawerVisible = true;
            });
      },
      getLinkedPlannedVisitId(visit) {
         return _.get(visit, 'plannedVisit.id')
            || _.get(visit, 'planned_visit.id')
            || _.get(visit, 'plannedVisitId')
            || _.get(visit, 'fk_planned_visit_id')
            || null;
      },
      hasReportedVisitForPlannedVisit(plannedVisit) {
         if (!this.isPlannedVisit(plannedVisit)) {
            return false;
         }

         const plannedVisitId = this.toComparableVisitId(_.get(plannedVisit, 'id') || _.get(plannedVisit, 'visitId'));
         if (plannedVisitId == null) {
            return false;
         }

         return (this.customerVisits || []).some((visit) => {
            if (this.isPlannedVisit(visit)) {
               return false;
            }
            const linkedPlannedId = this.toComparableVisitId(this.getLinkedPlannedVisitId(visit));
            return linkedPlannedId != null && linkedPlannedId === plannedVisitId;
         });
      },
      toComparableVisitId(value) {
         if (value == null || value === '') {
            return null;
         }
         return String(value);
      },
      getUnreportedPlannedCustomerVisits() {
         const visits = Array.isArray(this.customerVisits)
            ? this.customerVisits.filter((visit) => _.isPlainObject(visit))
            : [];

         const plannedVisits = visits.filter((visit) => this.isPlannedVisit(visit));
         if (plannedVisits.length === 0) {
            return [];
         }

         const linkedPlannedVisitIds = new Set(
            visits
               .filter((visit) => !this.isPlannedVisit(visit))
               .map((visit) => this.toComparableVisitId(this.getLinkedPlannedVisitId(visit)))
               .filter((id) => id != null)
         );

         return plannedVisits.filter((visit) => {
            const plannedVisitId = this.toComparableVisitId(_.get(visit, 'id') || _.get(visit, 'visitId'));
            if (plannedVisitId == null) {
               return false;
            }
            return !linkedPlannedVisitIds.has(plannedVisitId);
         });
      },
      pickSuggestedPlannedVisitForReportCreation(plannedVisits) {
         if (!Array.isArray(plannedVisits) || plannedVisits.length === 0) {
            return null;
         }

         const today = moment().startOf('day');
         const normalized = plannedVisits
            .map((visit) => ({
               visit,
               dateMoment: moment(this.getVisitDate(visit)).startOf('day'),
            }))
            .filter((entry) => entry.dateMoment.isValid());

         if (normalized.length === 0) {
            return plannedVisits[0];
         }

         const currentMonth = normalized
            .filter((entry) => entry.dateMoment.isSame(today, 'month'))
            .sort((a, b) => Math.abs(a.dateMoment.diff(today)) - Math.abs(b.dateMoment.diff(today)));
         if (currentMonth.length > 0) {
            return currentMonth[0].visit;
         }

         const future = normalized
            .filter((entry) => entry.dateMoment.isSameOrAfter(today))
            .sort((a, b) => a.dateMoment.valueOf() - b.dateMoment.valueOf());
         if (future.length > 0) {
            return future[0].visit;
         }

         const past = normalized
            .filter((entry) => entry.dateMoment.isBefore(today))
            .sort((a, b) => b.dateMoment.valueOf() - a.dateMoment.valueOf());
         if (past.length > 0) {
            return past[0].visit;
         }

         return plannedVisits[0];
      },
      maybeResolvePlannedVisitForReportCreation() {
         const unreportedPlannedVisits = this.getUnreportedPlannedCustomerVisits();
         if (unreportedPlannedVisits.length === 0) {
            return Promise.resolve(null);
         }

         const suggestedPlannedVisit = this.pickSuggestedPlannedVisitForReportCreation(unreportedPlannedVisits);
         if (suggestedPlannedVisit == null) {
            return Promise.resolve(null);
         }

         const plannedDateLabel = this.formatVisitPlannedDateTime(suggestedPlannedVisit);
         return this.$confirm(
            this.$i18n.t('clients.visitsList.reportAssociationPrompt', { date: plannedDateLabel }),
            this.$i18n.t('clients.visitsList.reportAssociationPromptTitle'),
            {
               confirmButtonText: 'Oui',
               cancelButtonText: 'Non',
               type: 'info',
            }
         )
            .then(() => suggestedPlannedVisit)
            .catch(() => null);
      },
      handleDeleteVisit(visit) {
         const visitId = _.get(visit, 'id');
         if (visitId == null) {
            this.$message.error(this.$i18n.t('clients.deleteVisitMissingId'));
            return;
         }

         this.$confirm(this.$i18n.t('clients.deleteVisitConfirm'), this.$i18n.t('common.Warning'), {
            confirmButtonText: this.$i18n.t('common.yes'),
            cancelButtonText: this.$i18n.t('common.Cancel'),
            type: 'warning',
         }).then(() => {
            return VisitAPI.deleteVisit(visitId)
               .then(() => {
                  if (_.get(this.visitToEdit, 'id') === visitId) {
                     this.closeVisitDrawer();
                  }
                  this.$message.success(this.$i18n.t('clients.deleteVisitSuccess'));
                  this.fetchVisitDistribution();
                  this.getCustomerInfo();
               })
               .catch(() => {
                  this.$message.error(this.$i18n.t('clients.deleteVisitError'));
               });
         }).catch(() => {
            // cancellation: no-op
         });
      },
      closeVisitDrawer() {
         this.visitDrawerVisible = false;
         this.visitToEdit = null;
         this.visitDrawerMode = 'report';
      },
      handleVisitSaved() {
         this.visitDrawerVisible = false;
         this.visitToEdit = null;
         this.visitDrawerMode = 'report';
         this.fetchVisitDistribution();
         this.getCustomerInfo();
      },
      handleCreateNewSalesOrder(){
         this.showSalesOrderDialog = true;
      },
      formatAmount(amount) {
          return portausUtils.formatAmount(amount, this.$i18n.locale);
		},
      sendSimpleStatement () {
         this.sendDialogVisible = true;
      },
      closeSendNoticeDialog () {
         this.sendDialogVisible = false;
      },
      noticeSent () {
         console.log('SENT');
      },
		fetchSales() {
			this.loading = true;
			const params = {
				customerId: this.customerId,
				}
			return salesAPI.getSalesEvolution(params)
			.then((sales) => {
            this.totalSales = _.head(sales);
				this.loading = false;
			})
		},
		getInfoTitle(info){
			return info[this.titleLang];
		},
		handleShowWalletManagementDialog(show) {
			if (show) {
				this.walletDialogVisible = true;
			} else {
				this.walletDialogVisible = false;
			}
		},
		handleChangeAccount (account) {
			if (this.customer.type === 0) {
				this.$set(this.customer.contact, 'account', account);
			} else {
				_.forEach(this.customer.company.contacts, c => {
					if (c.id === account.user.id) {
						this.$set(c, 'account', account);
					}
				})
			}
		},
 	fetchWebAccess () {
      if (this.isExternalAccountAPIModuleactive) {
         this.accessLoading = true;
            return accountAPI.fetchAccounts({ customerId: this.customer.id })
               .then((accounts) => {
                  this.webAccounts = accounts
                  this.accessLoading = false
               }).catch(() => {
                  this.accessLoading = false;
               })
      }
		
	},
    deleteCustomer() {
      return CustomerAPI.delete(this.customerId)
        .then(() => {
          this.invalidateList();
          this.$message.success(this.$i18n.t(`clients.deleted`));
          this.close();
        })
        .catch((error) => {
          if (error.response.status === 405) {
            let i18nMessage = null;
            const reasons = _.get(error.response, 'data.reasons');
            if (!_.isEmpty(reasons.reservations) && _.isEmpty(reasons.salesOrders) && _.isEmpty(reasons.invoices)) {
              i18nMessage = 'delete_error_reservations';
            } else if (_.isEmpty(reasons.reservations) && !_.isEmpty(reasons.salesOrders) && _.isEmpty(reasons.invoices)) {
              i18nMessage = 'delete_error_salesOrders';
            } else if (_.isEmpty(reasons.reservations) && _.isEmpty(reasons.salesOrders) && !_.isEmpty(reasons.invoices)) {
              i18nMessage = 'delete_error_invoices';
            } else if (!_.isEmpty(reasons.reservations) && !_.isEmpty(reasons.salesOrders) && _.isEmpty(reasons.invoices)) {
              i18nMessage = 'delete_error_reservations_salesOrders';
            } else if (!_.isEmpty(reasons.reservations) && _.isEmpty(reasons.salesOrders) && !_.isEmpty(reasons.invoices)) {
              i18nMessage = 'delete_error_reservations_invoices';
            } else if (_.isEmpty(reasons.reservations) && !_.isEmpty(reasons.salesOrders) && !_.isEmpty(reasons.invoices)) {
              i18nMessage = 'delete_error_salesOrders_invoices';
            } else {
              i18nMessage = 'delete_error_reservation_salesOrders_invoices';
            }

            this.$message.error(this.$i18n.t(`clients.${i18nMessage}`));
          } else {
            // this.$message.error("Oops... Une erreur est survenue!");
          }
        })
    },
    getCustomerName(customer){
      return CustomerUtil.customerName(customer.name, customer.usual_name, customer.type === 0);
    },
      getRepInitials(rep) {
         const firstName = _.get(rep, 'first_name', '');
         const lastName = _.get(rep, 'last_name', '');
         const extractInitials = (value) => String(value)
            .trim()
            .split(/\s+/)
            .filter((part) => part !== '')
            .map((part) => part.charAt(0).toUpperCase())
            .join('');
         const initials = `${extractInitials(firstName)}${extractInitials(lastName)}`;
         return initials || '?';
      },
    downloadReservationUpcomingOrderReport(){
      this.downloading=true;
      let filename = this.customerNameValue + "-reservations-upcoming-orders.pdf"
      return salesAPI.downloadReservationUpcomingOrderReport({ customerId: this.customerId}, filename)
        .then(()=>{
          this.downloading=false;
        }).catch(err=>{
          this.downloading=false;
          this.$message.error("Oops... Une erreur est survenue!");
        })
    },
    sendReservationReminder() {
      this.$confirm(this.$i18n.t('clients.sendReservationReminderConfirm'), this.$i18n.t('common.warning'), {
        confirmButtonText: this.$i18n.t('common.yes'),
        cancelButtonText: this.$i18n.t('common.Cancel'),
        type: 'warning',
      })
        .then(() => reservationAPI.sendReminderForCustomer(this.customerId))
        .then((result) => {
          if (result && result.sent > 0) {
            this.$message.success(this.$i18n.t('clients.sendReservationReminderSuccess'));
          } else {
            const reason = result && result.reason;
            const key = reason === 'NO_RESERVATIONS_OR_UPCOMING_ORDERS'
              ? 'clients.sendReservationReminderNothingToSend'
              : reason === 'CUSTOMER_INACTIVE'
                ? 'clients.sendReservationReminderCustomerInactive'
                : 'clients.sendReservationReminderNothingToSend';
            this.$message.warning(this.$i18n.t(key));
          }
        })
        .catch((err) => {
          if (err === 'cancel' || err === 'close') return;
          console.error(err);
          this.$message.error(this.$i18n.t('clients.sendReservationReminderError'));
        });
    },
    handleNoteEdition ({ note, index }) {
      this.noteToEdit = note;
      this.noteIndexToEdit = index;
      this.handleShowQuickNoteVisible();
    },
    handleShowQuickNoteVisible (){
      this.quickNoteModalVisible = true;
    },
    handleCloseQuickNoteVisible (){
      this.noteToEdit = null;
      this.noteIndexToEdit = null;
      this.quickNoteModalVisible = false;
    },
		convertCustomer(){
			this.fullScreenLoading = true;
			CustomerAPI.convertCustomer(this.customer.id)
				.then(()=> this.getCustomerInfo(this.customer.id))
				.then(()=>{
					this.fullScreenLoading = false;
					this.$message.success('Le client a été converti avec succès!')
				})
				.catch(err=>{
					console.log(err);
          this.fullScreenLoading = false;
					this.$message.error("Oups... Une erreur est survenue!")
				})
		},
		downloadStatement(filters){
			let startDate = null;
			let endDate = this.month.endDate;
			if(filters.period.code!='CUSTOM'){
				if(filters.period.code=='FISCAL_YEAR'){
					startDate = this.fiscalYearDate.startDate.format('YYYY-MM-DD');
					endDate = this.fiscalYearDate.endDate.format('YYYY-MM-DD');
				}else if(filters.period.code=='LAST_FISCAL_YEAR'){
					startDate = this.lastFiscalYearDate.startDate.format('YYYY-MM-DD');
					endDate = this.lastFiscalYearDate.endDate.format('YYYY-MM-DD');
				}else if(filters.period.code=='MONTH'){
					startDate = this.month.startDate.format('YYYY-MM-DD');
					endDate = this.month.endDate.format('YYYY-MM-DD');
				}else if(filters.period.code=='LAST_MONTH'){
					startDate = this.lastMonth.startDate.format('YYYY-MM-DD');
					endDate = this.lastMonth.endDate.format('YYYY-MM-DD');
				}else if(filters.period.code=='LAST_12_MONTH'){
					startDate = this.last12Month.startDate.format('YYYY-MM-DD');
					endDate = this.month.endDate.format('YYYY-MM-DD');
				}
			}else{
				startDate = moment(filters.dateRange[0]).format('YYYY-MM-DD');
				endDate = moment(filters.dateRange[1]).format('YYYY-MM-DD');
			}

			let filename = this.customer.name + "-statement-"+startDate+"-"+endDate
		  CustomerAPI.downloadStatementReport(this.customer.id, startDate, endDate, filename);
		},
		closeFilterDialog(){
			this.customerStatementVisible = false;
		},
		openSenerateStatementFilter(type){
      if (type !== 'SIMPLE') {
	       this.customerStatementVisible = true;
      } else {
        let filename = this.customer.name + "-statement-"+ moment().format('YYYY-MM-DD');
        CustomerAPI.downloadStatementReportV2(this.customer.id, null, null, filename, 'SIMPLE');
      }

		},
		refreshCustomer(customerUpdated){
			Object.assign(this.customer, customerUpdated);
         if (customerUpdated.parent == null) {
            this.customer.parent = null;
         }
			this.setCustomerFields(customerUpdated.custom_fields);

		},
		openCustomerEditor(){
			this.customerToEdit = this.customer;
			this.customerEditorVisible=true;
		},
		closeCustomerEditor(){
			this.customerEditorVisible=false;
		},
		_moment(datetime, format='LL'){
      return moment(datetime).format(format);

		},
		openSalesOrder(salesOrderId){
			var index='/sales-orders/'+salesOrderId;
			this.$router.push(index);
		},
		close(){
			this.$router.go(-1);
		},
		createInvoice(){
			// var index='/invoice';
			// this.$router.push(index);
		},
		createCredit(){
			this.creditEditorVisible = true;
		},
		openSettingsDialog() {
			this.dialogvisible = true
		},
		setPageWidth() {
			if (document.getElementById('page-panel') != null) {
				this.pageWidth = document.getElementById('page-panel').offsetWidth;
				this.pageHeight = document.getElementById('page-panel').offsetHeight;
			}	
		},
      handleTopNavScroll() {
         const container = this.$refs.scrollContainer;
         const scrollTop = container && typeof container.scrollTop === 'number' ? container.scrollTop : 0;
         this.isCustomerTopNavScrolled = scrollTop > 0;
      },
		archiveCustomerControl(){
			var message = this.customer.active?"Voulez-vous vraiment désactiver le client?":"Voulez-vous vraiment réactiver le client?";
			this.$confirm(message, 'Warning', {
          confirmButtonText: 'Oui',
          cancelButtonText: 'Annuler',
          type: 'warning'
        }).then(() => {
					this.fullScreenLoading=true;
					var putValue = {};
					putValue.active = !this.customer.active;
					axios.put(process.env.VUE_APP_PORTAUS_API_URL+":"+process.env.VUE_APP_PORTAUS_API_PORT+"/API/customers/"+this.customerId, putValue)
						.then(response=>{
							this.invalidateList();
							this.customer.active=putValue.active;
							this.fullScreenLoading=false;
							var message = putValue.active?"Le client a été réactivé.":"Le client a été désactivé."
							this.$notify({
								title: 'Succès',
								message: message,
								type: 'success'
					        });
						}).catch((err) => {
							this.$notify({
								title: 'Ooops!',
								message: 'Une erreur est survenue. Veuillez réessayer plus tard.',
								type: 'error'
									});
		        });
        }).catch(()=>{
					//do nothing
				})
		},
		updateCustomerCredit({creditNoteCreated, customerCredits}){
			this.customer.credit.credit = customerCredits;
		},
		getCustomerInfo(){
			return axios.get(process.env.VUE_APP_PORTAUS_API_URL+":"+process.env.VUE_APP_PORTAUS_API_PORT+"/API/customers/"+this.customerId)
			.then(response=>{
				return this.customer=response.data;
			})
		},
		fetchNextSalesOrderPage () {
			if (this.page < this.totalPages) {
				this.page += 1;
				this.getSalesOrders();
			}
		},
		fetchPreviousSalesOrderPage () {
			if (this.page > 1) {
				this.page -= 1;
				this.getSalesOrders();
			}
		},
		getSalesOrders(){
			SalesOrdersAPI.fetchSalesOrders({paging:'true',page: this.page, limit: this.salesOrderLimit, customerId:this.customerId, orderBy: 'date', direction: 'desc'})
				.then(salesOrders=>{
					this.totalPages = salesOrders.pages;
					this.salesOrders = salesOrders.list;
				})
		},
		setCustomerFields(){
			_.forEach(this.customer_fields, field=>{
				var fieldValue = _.find(this.customer.custom_fields, info=>{

					return field.id==info.id;
				})
				field.value = fieldValue!=null?fieldValue.value:null;
			})

		},
      fetchVisitDistribution() {
         const safeCustomerId = parseInt(this.customerId, 10);
         if (Number.isNaN(safeCustomerId) || safeCustomerId <= 0) {
            this.latestVisitDateFromVisits = null;
            this.customerVisits = [];
            this.visitDistributionRows = this.getVisitDomains().map((domain) => ({
               code: domain.code,
               label: domain.label,
               count: 0,
               color: domain.color,
               percent: 0,
            }));
            this.visitDistributionLoading = false;
            return Promise.resolve([]);
         }

         const requestId = ++this.visitFetchRequestId;
         this.visitDistributionLoading = true;
         return VisitAPI.fetchVisits({ paging: 'no', customerId: safeCustomerId })
            .then((visitsResponse) => {
               if (requestId !== this.visitFetchRequestId) {
                  return;
               }

               const visits = this.sanitizeVisits(this.normalizeVisitList(visitsResponse));
               this.customerVisits = visits;
               const reportedVisits = visits.filter((visit) => !this.isPlannedVisit(visit));
               const latestVisit = _.maxBy(reportedVisits, (visit) => {
                  const visitDate = this.getVisitDate(visit);
                  const ts = moment(visitDate).valueOf();
                  return Number.isNaN(ts) ? -Infinity : ts;
               });
               this.latestVisitDateFromVisits = latestVisit ? this.getVisitDate(latestVisit) : null;

               const countsByCode = {};
               visits.forEach((visit) => {
                  const typeCode = this.getVisitTypeCode(visit);
                  const code = _.find(this.getVisitDomains(), (domain) => domain.code === typeCode) ? typeCode : 'OTHER';
                  countsByCode[code] = (countsByCode[code] || 0) + 1;
               });

               const visitDomains = this.getVisitDomains();
               const totalVisits = _.sumBy(visitDomains, (domain) => countsByCode[domain.code] || 0);
               this.visitDistributionRows = visitDomains
                  .map((domain) => ({
                     code: domain.code,
                     label: domain.label,
                     count: countsByCode[domain.code] || 0,
                     color: domain.color,
                     percent: totalVisits > 0 ? Number((((countsByCode[domain.code] || 0) / totalVisits) * 100).toFixed(1)) : 0,
                  }));
            })
            .catch((error) => {
               if (requestId !== this.visitFetchRequestId) {
                  return;
               }
               this.latestVisitDateFromVisits = null;
               this.customerVisits = [];
               this.visitDistributionRows = this.getVisitDomains().map((domain) => ({
                  code: domain.code,
                  label: domain.label,
                  count: 0,
                  color: domain.color,
                  percent: 0,
               }));
               console.error('[Customer] Unable to fetch visits', error);
            })
            .finally(() => {
               if (requestId === this.visitFetchRequestId) {
                  this.visitDistributionLoading = false;
               }
            });
      },
      getVisitDomains() {
         return [
            { code: 'VISIT', label: this.$t('clients.visitTypeLabels.visit'), color: '#409eff', icon: 'mdi mdi-office-building' },
            { code: 'QUICK_CALL', label: this.$t('clients.visitTypeLabels.quickCall'), color: '#67c23a', icon: 'mdi mdi-phone-fast' },
            { code: 'PHONE_CALL', label: this.$t('clients.visitTypeLabels.phoneCall'), color: '#e6a23c', icon: 'mdi mdi-phone' },
            { code: 'EMAIL-SMS', label: this.$t('clients.visitTypeLabels.emailSms'), color: '#909399', icon: 'mdi mdi-email-outline' },
            { code: 'DELIVERY-PICK_UP', label: this.$t('clients.visitTypeLabels.deliveryPickUp'), color: '#f56c6c', icon: 'mdi mdi-truck-delivery-outline' },
            { code: 'DEGUSTATION', label: this.$t('clients.visitTypeLabels.degustation'), color: '#36cfc9', icon: 'mdi mdi-glass-wine' },
            { code: 'OTHER', label: this.$t('clients.visitTypeLabels.other'), color: '#b37feb', icon: 'mdi mdi-shape-outline' },
         ];
      },
      visitTypeLabel(code) {
         const domain = _.find(this.getVisitDomains(), (item) => item.code === code);
         return _.get(domain, 'label', code);
      },
      getVisitTypeIcon(code) {
         const domain = _.find(this.getVisitDomains(), (item) => item.code === code);
         return _.get(domain, 'icon', 'mdi mdi-shape-outline');
      },
      normalizeVisitList(visitsResponse) {
         if (Array.isArray(visitsResponse)) {
            return visitsResponse;
         }
         if (Array.isArray(_.get(visitsResponse, 'items'))) {
            return _.get(visitsResponse, 'items');
         }
         if (Array.isArray(_.get(visitsResponse, 'results'))) {
            return _.get(visitsResponse, 'results');
         }
         if (Array.isArray(_.get(visitsResponse, 'list'))) {
            return _.get(visitsResponse, 'list');
         }
         if (Array.isArray(_.get(visitsResponse, 'rows'))) {
            return _.get(visitsResponse, 'rows');
         }
         if (Array.isArray(_.get(visitsResponse, 'data'))) {
            return _.get(visitsResponse, 'data');
         }
         if (Array.isArray(_.get(visitsResponse, 'data.list'))) {
            return _.get(visitsResponse, 'data.list');
         }
         if (Array.isArray(_.get(visitsResponse, 'data.items'))) {
            return _.get(visitsResponse, 'data.items');
         }
         return [];
      },
      sanitizeVisits(visits) {
         if (!Array.isArray(visits)) {
            return [];
         }
         return visits.filter((visit) => _.isPlainObject(visit));
      },
      getVisitDate(visit) {
         return _.get(visit, 'date') || _.get(visit, 'visitDate') || _.get(visit, 'visitedAt') || _.get(visit, 'created_at') || null;
      },
      getVisitNextDate(visit) {
         return _.get(visit, 'nextVisitDate') || _.get(visit, 'next_visit_date') || null;
      },
      isPlannedVisit(visit) {
         return _.toUpper(_.get(visit, 'status')) === 'PLANNED';
      },
      getVisitUpcomingDate(visit) {
         if (this.isPlannedVisit(visit)) {
            return this.getVisitDate(visit);
         }
         return this.getVisitNextDate(visit);
      },
      getVisitStartTime(visit) {
         return _.get(visit, 'startTime') || _.get(visit, 'start_time') || null;
      },
      formatVisitNextDateTime(visit) {
         const nextVisitDate = this.getVisitNextDate(visit);
         if (nextVisitDate == null || nextVisitDate === '') {
            return '-';
         }

         const dateMoment = moment(nextVisitDate);
         if (!dateMoment.isValid()) {
            return '-';
         }

         const startTimeValue = this.getVisitStartTime(visit);
         if (startTimeValue == null || startTimeValue === '') {
            return dateMoment.format('YYYY-MM-DD');
         }

         const timeMatch = String(startTimeValue).trim().match(/(\d{2}:\d{2})/);
         const timeLabel = timeMatch == null ? null : timeMatch[1];
         if (timeLabel == null) {
            return dateMoment.format('YYYY-MM-DD');
         }

         return `${dateMoment.format('YYYY-MM-DD')} ${timeLabel}`;
      },
      formatVisitPlannedDateTime(visit) {
         const visitDate = this.getVisitDate(visit);
         if (visitDate == null || visitDate === '') {
            return '-';
         }

         const dateMoment = moment(visitDate);
         if (!dateMoment.isValid()) {
            return '-';
         }

         const startTimeValue = this.getVisitStartTime(visit);
         if (startTimeValue == null || startTimeValue === '') {
            return dateMoment.format('YYYY-MM-DD');
         }

         const timeMatch = String(startTimeValue).trim().match(/(\d{2}:\d{2})/);
         const timeLabel = timeMatch == null ? null : timeMatch[1];
         if (timeLabel == null) {
            return dateMoment.format('YYYY-MM-DD');
         }

         return `${dateMoment.format('YYYY-MM-DD')} ${timeLabel}`;
      },
      getVisitTypeCode(visit) {
         return _.get(visit, 'visitType.code') || _.get(visit, 'visit_type.code') || _.get(visit, 'type.code') || _.get(visit, 'type') || 'OTHER';
      },
      getVisitProducts(visit) {
         const products = _.get(visit, 'products') || [];
         if (!Array.isArray(products)) {
            return [];
         }
         return products.filter((product) => _.isPlainObject(product));
      },
      hasTruthyFlag(value) {
         return value === true || value === 1 || value === '1' || value === 'true';
      },
      isInterestedProduct(product) {
         return this.hasTruthyFlag(_.get(product, 'interested'));
      },
      isTastedProduct(product) {
         return this.hasTruthyFlag(_.get(product, 'tasted'));
      },
      normalizeInterestRating(value) {
         if (value == null) {
            return null;
         }
         return String(value).trim().toUpperCase();
      },
      getVisitInterestDomains() {
         return [
            { code: 'ORDER_IMMINENT', label: 'Cmd imminente', shortLabel: 'Imm.', color: '#2e7d32' },
            { code: 'LIKELY_RESERVE', label: 'Res probable', shortLabel: 'Res.', color: '#66bb6a' },
            { code: 'VERY_INTERESTED', label: 'Tres interesse', shortLabel: 'Tres', color: '#9ccc65' },
            { code: 'INTERESTED', label: 'Interesse', shortLabel: 'Int.', color: '#fbc02d' },
            { code: 'CURIOUS', label: 'Curieux', shortLabel: 'Cur.', color: '#fb8c00' },
            { code: 'NO_INTEREST', label: 'Aucun interet', shortLabel: 'Aucun', color: '#e53935' },
         ];
      },
      getVisitTastedProductsCount(visit) {
         return this.getVisitProducts(visit).filter((product) => {
            if (this.isTastedProduct(product)) {
               return true;
            }
            return !this.isInterestedProduct(product);
         }).length;
      },
      getVisitInterestedProductsCountByRating(visit, ratingCode) {
         const normalizedCode = this.normalizeInterestRating(ratingCode);
         return this.getVisitProducts(visit).filter((product) => {
            if (!this.isInterestedProduct(product)) {
               return false;
            }
            return this.normalizeInterestRating(_.get(product, 'rating')) === normalizedCode;
         }).length;
      },
      getVisitInterestedProductsTotal(visit) {
         return this.getVisitProducts(visit).filter((product) => this.isInterestedProduct(product)).length;
      },
      getVisitInterestRows(visit) {
         return this.getVisitInterestDomains().map((domain) => ({
            ...domain,
            count: this.getVisitInterestedProductsCountByRating(visit, domain.code),
         }));
      },
      getVisitInterestSummaryRows(visit) {
         const rows = this.getVisitInterestRows(visit).filter((row) => row.count > 0);
         const total = _.sumBy(rows, 'count');
         if (total <= 0) {
            return [];
         }
         return rows.map((row) => ({
            ...row,
            percent: Number(((row.count / total) * 100).toFixed(1)),
         }));
      },
      getVisitInterestExplanation(code) {
         const explanations = {
            ORDER_IMMINENT: 'Client pret a commander tres prochainement.',
            LIKELY_RESERVE: 'Client avec forte probabilite de reservation.',
            VERY_INTERESTED: 'Interet eleve, suivi prioritaire recommande.',
            INTERESTED: 'Interet confirme pour au moins un produit.',
            CURIOUS: 'Interet exploratoire, besoin de relance.',
            NO_INTEREST: 'Aucun interet exprime pour le moment.',
         };
         return explanations[code] || '';
      },
      getVisitInterestTooltip(row) {
         const explanation = this.getVisitInterestExplanation(row.code);
         if (explanation === '') {
            return `${row.label}: ${row.count}`;
         }
         return `${row.label}: ${row.count} - ${explanation}`;
      },
      getVisitNotes(visit) {
         return _.get(visit, 'notes') || _.get(visit, 'comment') || _.get(visit, 'description') || '-';
      },
      getVisitContactsSummary(visit) {
         const visitedContacts = _.get(visit, 'visitedContacts') || _.get(visit, 'visited_contacts') || _.get(visit, 'contacts') || [];
         if (!Array.isArray(visitedContacts) || visitedContacts.length === 0) {
            return '-';
         }
         return visitedContacts
            .map((contact) => {
               const fullName = `${_.get(contact, 'first_name', '')} ${_.get(contact, 'last_name', '')}`.trim();
               return fullName || _.get(contact, 'name') || _.get(contact, 'email') || '-';
            })
            .filter((value) => value && value !== '-')
            .join(', ') || '-';
      },
      getAddressQuery(address) {
         if (address == null) {
            return '';
         }

         const civicNumber = _.get(address, 'civic_number')
            || _.get(address, 'street_number')
            || _.get(address, 'number')
            || _.get(address, 'no')
            || null;

         const streetName = _.get(address, 'street')
            || _.get(address, 'line_1')
            || _.get(address, 'address_1')
            || null;

         const streetLine = [civicNumber, streetName]
            .filter((part) => part != null && String(part).trim() !== '')
            .map((part) => String(part).trim())
            .join(' ');

         const parts = [
            streetLine,
            _.get(address, 'line_2') || _.get(address, 'address_2') || null,
            _.get(address, 'city'),
            _.get(address, 'state_name') || _.get(address, 'state.name') || _.get(address, 'other_state') || null,
            _.get(address, 'country_name') || _.get(address, 'country.name') || null,
            _.get(address, 'postal_code'),
         ];
         return _.chain(parts)
            .filter((part) => part != null && String(part).trim() !== '')
            .map((part) => String(part).trim())
            .join(', ')
            .value();
      },
      getAddressMapEmbedUrl(address) {
         const query = this.getAddressQuery(address);
         if (query === '') {
            return null;
         }
         return `https://maps.google.com/maps?q=${encodeURIComponent(query)}&z=14&output=embed`;
      },
      getAddressMapLink(address) {
         const query = this.getAddressQuery(address);
         if (query === '') {
            return '#';
         }
         return `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(query)}`;
      },
		...mapActions('controlData',['fetchDeliveryTypes','fetchLocations']),
		...mapActions('customers', ['invalidateList'])
	},
	computed: {
      customerId() {
         const routeId = parseInt(this.$route.params.id, 10);
         if (!Number.isNaN(routeId)) {
            return routeId;
         }
         if (_.get(this, 'customer.id') != null) {
            return parseInt(_.get(this, 'customer.id'), 10);
         }
         return null;
      },
		portausCompany () {
			return _.get(this.customer, 'portausCompany.id');
		},
	lang() {
		return this.$i18n.locale;
	},
	titleLang(){
		return `title_${this.lang}`;
	},
	isNotEmpty () {
		return _.size(this.salesOrders) > 0;
	},
    isCustomerActive () {
      return _.get(this.customer, 'active');
    },
    customerNameValue(){
      if (this.customer != null) {
        return this.getCustomerName(this.customer);
      }
      return "";
    },
      lastVisitDateValue() {
         const hasFetchedVisits = Array.isArray(this.customerVisits) && this.customerVisits.length > 0;
         if (!this.visitDistributionLoading && !hasFetchedVisits) {
            return null;
         }

         const customerLastVisit = _.get(this.customer, 'last_visit') || _.get(this.customer, 'lastVisit') || null;
         const visitLastDate = this.latestVisitDateFromVisits;

         const customerMoment = customerLastVisit ? moment(customerLastVisit) : null;
         const visitMoment = visitLastDate ? moment(visitLastDate) : null;

         const customerValid = customerMoment != null && customerMoment.isValid();
         const visitValid = visitMoment != null && visitMoment.isValid();

         if (customerValid && visitValid) {
            return customerMoment.isAfter(visitMoment) ? customerLastVisit : visitLastDate;
         }
         if (visitValid) {
            return visitLastDate;
         }
         if (customerValid) {
            return customerLastVisit;
         }
         return null;
      },
      formattedLastVisitDate() {
         if (this.lastVisitDateValue == null) {
            return 'Aucune visite';
         }
         return moment(this.lastVisitDateValue).format('YYYY-MM-DD');
      },
      daysSinceLastVisit() {
         if (this.lastVisitDateValue == null) {
            return null;
         }
         return moment().startOf('day').diff(moment(this.lastVisitDateValue).startOf('day'), 'days');
      },
      lastVisitStatusClass() {
         if (this.daysSinceLastVisit == null) {
            return 'visit-status-neutral';
         }
         if (this.daysSinceLastVisit < 30) {
            return 'visit-status-good';
         }
         if (this.daysSinceLastVisit <= 60) {
            return 'visit-status-warning';
         }
         return 'visit-status-alert';
      },
      lastVisitStatusLabel() {
         if (this.daysSinceLastVisit == null) {
            return this.$t('clients.lastVisitStatus.noData');
         }
         if (this.daysSinceLastVisit < 30) {
            return this.$t('clients.lastVisitStatus.upToDate', { days: this.daysSinceLastVisit });
         }
         if (this.daysSinceLastVisit <= 60) {
            return this.$t('clients.lastVisitStatus.toMonitor', { days: this.daysSinceLastVisit });
         }
         return this.$t('clients.lastVisitStatus.overdue', { days: this.daysSinceLastVisit });
      },
      nextVisitDateValue() {
         const rawDates = [];
         const visitBasedDates = [];

         const customerNextVisitDate = _.get(this.customer, 'nextVisitDate')
            || _.get(this.customer, 'next_visit_date')
            || _.get(this.customer, 'nextVisit')
            || _.get(this.customer, 'next_visit')
            || null;

         (this.customerVisits || []).forEach((visit) => {
            if (this.isPlannedVisit(visit) && this.hasReportedVisitForPlannedVisit(visit)) {
               return;
            }
            const nextDate = this.getVisitUpcomingDate(visit);
            if (nextDate != null && nextDate !== '') {
               visitBasedDates.push(nextDate);
            }
         });

         if (visitBasedDates.length > 0) {
            rawDates.push(...visitBasedDates);
         } else if (customerNextVisitDate != null && customerNextVisitDate !== '') {
            rawDates.push(customerNextVisitDate);
         }

         if (rawDates.length === 0) {
            return null;
         }

         const today = moment().startOf('day');
         const nextDates = rawDates
            .map((dateValue) => moment(dateValue))
            .filter((dateMoment) => dateMoment.isValid() && dateMoment.startOf('day').isSameOrAfter(today));

         if (nextDates.length === 0) {
            return null;
         }

         const closestNextDate = _.minBy(nextDates, (dateMoment) => dateMoment.valueOf());
         return closestNextDate ? closestNextDate.format('YYYY-MM-DD') : null;
      },
      formattedNextVisitDate() {
         if (this.nextVisitDateValue == null) {
            return '-';
         }
         return moment(this.nextVisitDateValue).format('YYYY-MM-DD');
      },
      isNextVisitToday() {
         if (this.nextVisitDateValue == null) {
            return false;
         }
         return moment(this.nextVisitDateValue).startOf('day').isSame(moment().startOf('day'));
      },
      totalVisitCount() {
         return _.sumBy(this.visitDistributionRows, 'count');
      },
      latestVisitForReport() {
         if (!Array.isArray(this.sortedReportedCustomerVisits) || this.sortedReportedCustomerVisits.length === 0) {
            return null;
         }
         return this.sortedReportedCustomerVisits[0] || null;
      },
      sortedReportedCustomerVisits() {
         return _.orderBy((this.customerVisits || []).filter((visit) => !this.isPlannedVisit(visit)), [(visit) => {
            const ts = moment(_.get(visit, 'date')).valueOf();
            return Number.isNaN(ts) ? 0 : ts;
         }], ['desc']);
      },
      sortedUpcomingPlannedCustomerVisits() {
         const today = moment().startOf('day');
         return _.orderBy((this.customerVisits || []).filter((visit) => {
            if (!this.isPlannedVisit(visit)) {
               return false;
            }
            if (this.hasReportedVisitForPlannedVisit(visit)) {
               return false;
            }
            const visitDate = moment(this.getVisitDate(visit));
            return visitDate.isValid() && visitDate.startOf('day').isSameOrAfter(today);
         }), [(visit) => {
            const ts = moment(_.get(visit, 'date')).valueOf();
            return Number.isNaN(ts) ? 0 : ts;
         }], ['asc']);
      },
      sortedCustomerVisits() {
         return _.orderBy(this.customerVisits || [], [(visit) => {
            const ts = moment(_.get(visit, 'date')).valueOf();
            return Number.isNaN(ts) ? 0 : ts;
         }], ['desc']);
      },
    tabHeight(){
      return 'height: auto; min-height: 400px; overflow: visible;'
    },
		convertClientType(){
			if(this.customer==null) return "";
			return this.customer.type==1 ? this.$i18n.t('clients.types.individuel') : this.$i18n.t('clients.types.corporate');
		},
	companyName(){
	  if (localStorage.CIE_INFO == null) return null;
      return _.get(JSON.parse(localStorage.CIE_INFO), 'name');
    },
    fiscalEndDay(){
	  if (localStorage.CIE_INFO == null) return null;
	  return _.get(JSON.parse(localStorage.CIE_INFO), 'fiscalEndDay');
    },
    fiscalEndMonth(){
	  if (localStorage.CIE_INFO == null) return null;
      return _.get(JSON.parse(localStorage.CIE_INFO), 'fiscalEndMonth');
    },
    reportCode(){
      return this.$route.params.code;
    },
    lastFiscalYearDate(){
      let lastFiscalYearDate = {};
      let fiscalYearDate = this.fiscalYearDate;
      if(fiscalYearDate.startDate!=null && fiscalYearDate.endDate!=null){
        let startDate = moment(fiscalYearDate.startDate,'DD MMM YYYY').subtract(1,'year');
        let endDate = moment(fiscalYearDate.endDate,'DD MMM YYYY').subtract(1,'year');
        lastFiscalYearDate = {startDate, endDate}
      }

      return lastFiscalYearDate;
    },
    fiscalYearDate(){
      let fiscalYearDate = {};
      if(this.fiscalEndDay!=null && this.fiscalEndMonth!=null){
        let endDate = null;
        if(moment().format('M')>this.fiscalEndMonth){
          endDate = moment(this.fiscalEndMonth.toString()+'-'+this.fiscalEndDay.toString(),'MM-DD').add(1,'year');
        }else{
          endDate = moment(this.fiscalEndMonth.toString()+'-'+this.fiscalEndDay.toString(),'MM-DD');
        }
        let startDate = moment(endDate).subtract(1, 'year').add(1,'day');
        fiscalYearDate = {startDate, endDate};
      }
      return fiscalYearDate
    },
    month(){
      return {startDate : moment().startOf('month'), endDate : moment().endOf('month')}
    },
    lastMonth(){
      return {startDate : moment().subtract(1,'months').startOf('month'), endDate : moment().subtract(1,'months').endOf('month')}
    },
    last12Month(){
      return {startDate : moment().subtract(12,'months').startOf('month'), endDate : moment().subtract(1,'months').endOf('month')}
    },
		predefinedPeriod(){
      if(this.fiscalYearDate.startDate!=null && this.fiscalYearDate.endDate!=null){
        return [
					{code : 'MONTH', description:this.month.startDate.format('DD MMM YYYY') + '-' + this.month.endDate.format('DD MMM YYYY')},
          {code : 'LAST_MONTH', description:this.lastMonth.startDate.format('DD MMM YYYY') + '-'+this.lastMonth.endDate.format('DD MMM YYYY')},
					{code : 'LAST_12_MONTH', description:this.last12Month.startDate.format('DD MMM YYYY') + '-' + this.month.endDate.format('DD MMM YYYY')},
					{code : 'FISCAL_YEAR',description:this.fiscalYearDate.startDate.format('DD MMM YYYY') + '-'+this.fiscalYearDate.endDate.format('DD MMM YYYY')},
          {code : 'LAST_FISCAL_YEAR',description:this.lastFiscalYearDate.startDate.format('DD MMM YYYY') + '-'+this.lastFiscalYearDate.endDate.format('DD MMM YYYY')},
          {code : 'CUSTOM', range:true}
        ]
      }else{
        return [];
      }

    },
		deliveryDays(){
			if(this.deliveryScheduleType==="FIXEDDAYS"){
				let scheduleArray = _.filter(this.customer.customer_delivery_schedules, s=>{return s.active})
				let str = "";
				_.forEach(scheduleArray, (d,i)=>{
					str+=this.$i18n.t('sales_orders.deliveryDay_'+d.day);
					if(i+1<scheduleArray.length){str+=", ";}
				})
				return str;
			}else{
				return "";
			}
		},
		deliveryScheduleType(){
			if(this.customer.customer_delivery_schedules!=null && this.customer.customer_delivery_schedules.length>0){
				if(this.customer.customer_delivery_schedules[0].year==null){
					//fixedDays
					return "FIXEDDAYS";
				}
			}
			return null;
		},
		deliveryType(){
			if(this.customer.delivery_type!=null){
				return this.deliveryTypeByLanguage({lang:this.$i18n.locale,id:this.customer.delivery_type.id}).name;
			}
			return null;
		},
		getHeightStyle(){
			return "min-height :"+(this.pageHeight-100) + "px"
		},
    defaultEmailContent() {
      const name = this.customerNameValue;
      if (this.lang === 'fr') {
        return `Bonjour,\n\nVeuillez trouver ci-joint votre état de compte.\n\nSi vous avez des questions concernant ce document, n'hésitez pas à nous contacter.\n\nCordialement`;
      }
      return `Hello,\n\nPlease find attached your account statement.\n\nIf you have any questions regarding this document, please do not hesitate to contact us.\n\nKind regards`;
    },
    total_paid () {
      let totalPaid = 0;
      if (_.get(this.customer, 'balance_account.paid') != null) {
        totalPaid = _.get(this.customer, 'balance_account.paid');
      }
      return totalPaid;
    },
		total_revenue(){
			if(this.customer!==null && this.customer.balance_account!=null){
				return this.customer.balance_account.invoiced.toString()
			}
			return '0.00';
		},
		overdue(){
			if(this.customer!==null && this.customer.balance_account!=null){
				return this.customer.balance_account.overdue.toString()
			}
			return '0.00';
		},
		outstanding(){
			if(this.customer!==null && this.customer.balance_account!=null){
				return this.customer.balance_account.outstanding.toString()
			}
			return '0.00';
		},
		draft(){
			if(this.customer!==null && this.customer.balance_account!=null){
				return this.customer.balance_account.draft.toString()
			}
			return '0.00';
		},
		credit(){
			if(this.customer!==null && this.customer.balance_account!=null){
				return this.customer.balance_account.credit.toString()
			}
			return '0.00';
		},
		getContacts(){
			if(this.customer==null){
				return null
			}else{
				if(this.isIndividual){
					return [this.customer.contact]
				}else{
					return this.customer.company.contacts;
				}
			}
		},
		getAddresses(){
			if(this.customer==null){
				return null
			}else{
				if(this.isIndividual){
					return _.get(this.customer, 'contact.addresses');
				}else{
					return this.customer.company==null?null:this.customer.company.addresses;
				}
			}
		},
		isIndividual(){
			return this.customer.company==null;
		},
    getTypeOfCustomer(){
      if(this.isIndividual){
        return this.$i18n.t('clients.types.individuel');
      }
    	return this.$i18n.t('clients.types.corporatif');
    },
		...mapGetters('controlData', [ 'deliveryTypeByLanguage']),
		...mapGetters(['isInvoicingModuleactive', 'isExternalAccountAPIModuleactive']),
      ...mapGetters('inventory', ['isMultipleInventorySystem'])
	},
   mounted() {
		this.setPageWidth();
		if(this.$route.query.activeTab!=null){
			this.activeTab = this.$route.query.activeTab;
		}

		this.fetchDeliveryTypes();
		this.fetchSales();
      this.getSalesOrders();
      this.fetchVisitDistribution();

      this.$nextTick(() => {
         const container = this.$refs.scrollContainer;
         if (container) {
            container.addEventListener('scroll', this.handleTopNavScroll, { passive: true });
            this.handleTopNavScroll();
         }
      });

      return this.getCustomerInfo()
         .then(customerInfo=>{

				this.customer = customerInfo;

				const ps = new VuePerfectScrollbar(this.$refs.scrollContainer);
				this.fullScreenLoading=false;


				this.setCustomerFields();
				this.fetchWebAccess();


			}).catch(err=>{
				console.log(err);
			})


	}
   ,
   beforeDestroy() {
      const container = this.$refs.scrollContainer;
      if (container) {
         container.removeEventListener('scroll', this.handleTopNavScroll);
      }
   }
}
</script>

<style lang="scss" scoped>
@import '../../../assets/scss/_variables';



.contact-fiche-info{
	padding-left:10px!important;
}
  .title {
  	font-size : 1.6em;
  	font-weight:bold;
  	margin-right:10px;
  	margin-left:10px;
  	position:relative;
  	float:left;
  }
	.title.inactive{
			text-decoration: line-through;
		}
	.subtitle {
		font-size : 1em;
		top:10px;
		font-weight:normal;
		margin-right:20px;
		margin-left:0px;
		position:relative;
		float:left;
	}
.customer-top-nav-shell {
   position: sticky;
   top: 0;
   z-index: 20;
   margin-top: 10px;
   padding: 0 2px 6px;
}

.customer-top-nav-card {
   border-radius: 12px;
   border: 1px solid #e6edf5;
   background: linear-gradient(180deg, #ffffff 0%, #f9fbff 100%);
   box-shadow: 0 3px 10px rgba(17, 24, 39, 0.06);
   transition: box-shadow .18s ease, border-color .18s ease;
}

.customer-top-nav-card ::v-deep .el-card__body {
   padding: 10px 12px;
}

.customer-top-nav-card--scrolled {
   border-color: #dbe7f5;
   box-shadow: 0 8px 18px rgba(17, 24, 39, 0.1);
}

.customer-main-card {
   border-radius: 12px;
}

.customer-top-nav{
	display:flex;
	align-items:center;
	min-height:50px;
   height:auto;
   width:100%;
   background: transparent;
   padding: 2px 4px;
   box-sizing: border-box;
}

  .customer-page-header{
   flex:1 1 auto;
   min-width:0;
   overflow:hidden;
  }

  .customer-name-text{
   display:inline-block;
   max-width:100%;
   overflow:hidden;
   text-overflow:ellipsis;
   white-space:nowrap;
   vertical-align:middle;
  }
.customer-settings, .customer-type{
	font-size : 1.0em;
	// position:relative;
	margin-right:5px;
  	// float:left;
  	// margin-top:-5px;
}
.customer-inline-tags{
   display:inline-flex;
   flex-wrap:nowrap;
   align-items:center;
   gap:4px;
   margin-left:6px;
   vertical-align:middle;
}

.customer-inline-tag{
   margin:0;
}

.customer-settings:hover{
	color:#4a596a;
	cursor:pointer;
}
.customer-controls{
	position:relative;
	float:none;
   margin-left:auto;
   display:flex;
   align-items:center;
   gap:5px;
	button{
		margin-left:20px;
	}
}

.action-button {
  position: relative;
  float:right;
}

.customer-tab-nav {
   width: 100%;
   text-align: center;
   overflow-x: auto;
   overflow-y: hidden;
   -webkit-overflow-scrolling: touch;
   padding-bottom: 4px;
}

.customer-tab-group {
   display: inline-flex;
   flex-wrap: nowrap;
   white-space: nowrap;
}

.customer-tab-label {
   margin-left: 6px;
}

.customer-tab-nav-mobile {
   display: none;
   margin-bottom: 8px;
}

.customer-tab-select {
   width: 100%;
}

.stats-group-title {
   font-size: 13px;
   font-weight: 600;
   color: #303133;
   margin-bottom: 10px;
}

.stats-group-title--sub {
   font-size: 12px;
   color: #606266;
}

.stats-group-title--secondary {
   color: #909399;
}

.stats-block {
   border: 1px solid #ebeef5;
   border-radius: 10px;
   padding: 12px;
   background: #ffffff;
}

.customer-stats-section {
   margin-top: 12px;
   margin-bottom: 14px;
}

.stats-overview-layout {
   align-items: stretch;
}

.stats-finance-block {
   height: 100%;
}

.finance-priority-row {
   display: grid;
   grid-template-columns: repeat(2, minmax(0, 1fr));
   gap: 10px;
   margin-bottom: 10px;
}

.finance-priority-item {
   border-radius: 8px;
   padding: 10px;
   border: 1px solid transparent;
}

.finance-priority-item--danger {
   background: #fef0f0;
   border-color: #fbc4c4;
}

.finance-priority-item--warning {
   background: #fdf6ec;
   border-color: #f8d7a8;
}

.finance-priority-label {
   font-size: 11px;
   color: #606266;
}

.finance-priority-value {
   font-size: 24px;
   font-weight: 700;
   color: #303133;
}

.finance-compact-grid {
   display: grid;
   grid-template-columns: repeat(2, minmax(0, 1fr));
   gap: 8px;
}

.finance-compact-item {
   display: flex;
   justify-content: space-between;
   align-items: center;
   border: 1px solid #ebeef5;
   border-radius: 8px;
   padding: 7px 9px;
   background: #fafafa;
}

.finance-compact-label {
   font-size: 11px;
   color: #606266;
}

.finance-compact-value {
   font-size: 13px;
   font-weight: 700;
   color: #303133;
}

.stats-visit-block {
   background: #fafbfd;
   height: 100%;
}

.visit-indicators-row {
   display: grid;
   grid-template-columns: repeat(2, minmax(0, 1fr));
   gap: 10px;
   align-items: start;
}

.visit-indicator-card {
   border: 1px solid #ebeef5;
   border-radius: 10px;
   background: #fff;
   padding: 12px;
   min-height: 100px;
}

.visit-indicator-card--distribution {
   padding: 10px;
   min-height: 0;
}

.visit-indicator-label {
   font-size: 12px;
   color: #606266;
   margin-bottom: 6px;
}

.visit-indicator-value {
   font-size: 20px;
   font-weight: 600;
   color: #303133;
   margin-bottom: 8px;
}

.visit-indicator-head {
   display: inline-flex;
   align-items: flex-start;
   gap: 6px;
}

.visit-indicator-main {
   display: inline-flex;
   flex-direction: column;
   align-items: flex-start;
   gap: 6px;
}

.visit-indicator-report-action {
   padding: 0;
   line-height: 1;
   margin-top: 1px;
}

.visit-indicator-empty {
   display: inline-flex;
   align-items: center;
   flex-wrap: wrap;
   gap: 8px;
   font-size: 13px;
   color: #f56c6c;
}

.visit-indicator-empty-icon {
   font-size: 18px;
   color: #f56c6c;
}

.visit-indicator-empty-action {
   padding: 0;
   margin-left: 2px;
}

.visit-next-row {
   margin-top: 8px;
   padding-top: 8px;
   border-top: 1px solid #f0f2f5;
   display: inline-flex;
   align-items: center;
   gap: 6px;
   flex-wrap: wrap;
}

.visit-next-label {
   font-size: 11px;
   color: #909399;
}

.visit-next-value {
   font-size: 12px;
   color: #303133;
   font-weight: 600;
}

.visit-next-action {
   padding: 0;
   margin-left: 2px;
}

.visit-indicator-badge {
   display: inline-block;
   font-size: 12px;
   font-weight: 600;
   border-radius: 14px;
   padding: 4px 10px;
}

.visit-status-good {
   background: #f0f9eb;
   color: #67c23a;
}

.visit-status-warning {
   background: #fdf6ec;
   color: #e6a23c;
}

.visit-status-alert {
   background: #fef0f0;
   color: #f56c6c;
}

.visit-status-neutral {
   background: #f4f4f5;
   color: #909399;
}

.visit-distribution-compact {
   display: grid;
   gap: 6px;
}

.visit-distribution-bar {
   display: flex;
   width: 100%;
   height: 10px;
   border-radius: 999px;
   overflow: hidden;
   background: #eef2f7;
}

.visit-distribution-segment {
   height: 100%;
   min-width: 2px;
}

.visit-distribution-legend {
   display: flex;
   flex-wrap: wrap;
   gap: 6px;
   overflow-x: visible;
   padding-bottom: 2px;
}

.visit-distribution-pill {
   display: inline-flex;
   align-items: center;
   gap: 4px;
   border: 1px solid #ebeef5;
   border-radius: 999px;
   padding: 3px 7px;
   background: #fff;
   white-space: nowrap;
}

.visit-distribution-dot {
   width: 7px;
   height: 7px;
   border-radius: 999px;
   flex: 0 0 7px;
}

.visit-distribution-grid {
   display: grid;
   grid-template-columns: minmax(0, 1fr);
   row-gap: 4px;
}

.visit-distribution-item {
   display: flex;
   justify-content: space-between;
   align-items: center;
   border: 1px solid #ebeef5;
   border-radius: 8px;
   padding: 4px 6px;
}

.visit-distribution-type {
   font-size: 11px;
   color: #606266;
}

.visit-distribution-count {
   font-size: 12px;
   font-weight: 700;
   color: #303133;
}

.visit-interest-counts {
   display: flex;
   flex-wrap: wrap;
   gap: 4px;
}

.visit-interest-cell {
   min-width: 180px;
}

.visit-interest-bar {
   display: flex;
   width: 100%;
   height: 8px;
   border-radius: 999px;
   overflow: hidden;
   background: #eef2f7;
   margin-bottom: 6px;
}

.visit-interest-segment {
   height: 100%;
   min-width: 2px;
}

.visit-interest-legend-compact {
   display: flex;
   flex-wrap: wrap;
   gap: 4px;
}

.visit-interest-legend-item {
   display: inline-flex;
   align-items: center;
   gap: 4px;
   border: 1px solid #ebeef5;
   border-radius: 999px;
   padding: 2px 6px;
   background: #fafafa;
   white-space: nowrap;
}

.visit-interest-dot {
   width: 7px;
   height: 7px;
   border-radius: 999px;
   flex: 0 0 7px;
}

.visit-interest-short-label {
   font-size: 11px;
   color: #606266;
}

.visit-interest-count {
   font-size: 11px;
   font-weight: 700;
   color: #303133;
}

.visit-row-actions {
   display: inline-flex;
   align-items: center;
   gap: 4px;
}

.visit-interest-pill {
   border: 1px solid #ebeef5;
   border-radius: 999px;
   padding: 2px 8px;
   font-size: 11px;
   line-height: 1.4;
   color: #606266;
   background: #fafafa;
   white-space: nowrap;
}

.customer-address-item {
   margin: 10px;
}

.customer-address-card {
   margin: 0;
}

.customer-address-map-card {
   border: 1px solid #ebeef5;
   border-radius: 8px;
   padding: 8px;
   margin-top: 6px;
   background: #ffffff;
}

.customer-address-map-header {
   display: flex;
   align-items: center;
   justify-content: space-between;
   margin-bottom: 6px;
}

.customer-address-map {
   border: 0;
   width: 100%;
   height: 140px;
   border-radius: 6px;
}

.rep-initials-avatar {
   display: inline-flex;
   align-items: center;
   justify-content: center;
   width: 24px;
   height: 24px;
   margin-left: 8px;
   border-radius: 50%;
   background: #ecf5ff;
   border: 1px solid #c6e2ff;
   color: #409eff;
   font-size: 11px;
   font-weight: 700;
   vertical-align: middle;
}

  .client-tabs{
  	margin-top:20px;
  }

div.sticky {
  position: -webkit-sticky; /* Safari */
  position: sticky;
  top: 0;
}

@media screen and (max-width: 767px) {
   .customer-top-nav-shell {
      margin-top: 8px;
      padding: 0 0 6px;
   }

   .customer-top-nav{
      display:flex;
      flex-direction:column;
      align-items:stretch;
      gap:6px;
      height:auto;
   }

   .customer-page-header{
      width:100%;
      min-width:0;
   }

   .customer-inline-tags{
      margin-left:6px;
      max-width:65vw;
      overflow-x:auto;
      overflow-y:hidden;
   }

   .customer-controls{
      float:none;
      flex:0 0 auto;
      width:100%;
      margin-left:0;
      justify-content:flex-end;
      flex-wrap:wrap;
      white-space:normal;
      z-index:2;
      gap:6px;
      button{
         margin-left:0;
      }
   }

   .customer-controls .el-dropdown{
      flex:1 1 180px;
      min-width:160px;
   }

   .customer-controls .el-dropdown .el-button{
      width:100%;
      text-align:center;
   }

   .customer-tab-nav--desktop {
      display: none;
   }

   .customer-tab-nav-mobile {
      display: block;
   }

   .customer-tab-select ::v-deep .el-input__inner {
      border-radius: 8px;
      min-height: 40px;
   }

   .visit-indicators-row {
      grid-template-columns: minmax(0, 1fr);
   }
}


</style>
